import React, { useEffect, useState, useContext, Component } from 'react';
import { RitualContext, useRituals, Ritual, LootboxReward } from './RitualContext';
import { LootboxDashboard } from './LootboxDashboard';
import { LootboxOpening } from './LootboxOpening';
import { Trophy, Calendar, Gift, Zap, MessageSquare, Heart, Camera, Diamond, ChevronRight, CheckCircle, FastForward, Package, Sparkles, LockIcon, UnlockIcon, AlertTriangle, Flame, ArrowRight, DollarSign, ShoppingCart, Unlock, Clock, RefreshCw, RotateCw, Hourglass, Coins, Crown, Gamepad2, Image, Video, Star, LogIn, Users, User, MessageCircle, Bookmark, Palette, Play, BarChart2, Award, Share2, Ticket, FileText, Glasses, ClipboardList, UserPlus, Sticker, Laugh, Theater, Film, Music, ListMusic, HelpCircle, Shuffle, CheckCircle2, Brain, Shirt, X, Wand2, ImagePlus, Smile, PartyPopper, Brush, Scissors, PersonStanding, Scan, ScanFace } from 'lucide-react';
import { toast } from 'sonner';
import { useQuestionnaire } from '../personalization/QuestionnaireContext';
import { PhotoRatingFlow } from '../PhotoRatingFlow';
import { DickpicRatingUpsell } from '../DickpicRatingUpsell';
export const RitualBoard: React.FC = () => {
  const {
    dailyRituals,
    weeklyRituals,
    funRituals,
    premiumRituals,
    streakCount,
    weeklyStreakCount,
    hasUnclaimedRewards,
    pendingLootbox,
    claimDailyRewards,
    claimWeeklyLootbox,
    completeRitual,
    skipRitual,
    updateRitualProgress,
    todayCompletedCount,
    totalDailyRituals,
    weeklyCompletedCount,
    totalWeeklyRituals,
    areAllRequiredRitualsCompleted,
    rotateRituals,
    lastDailyRotation,
    lastWeeklyRotation
  } = useRituals();
  const [activeTab, setActiveTab] = useState<'daily' | 'weekly' | 'fun' | 'monetization' | 'premium'>('daily');
  const [showLootbox, setShowLootbox] = useState(false);
  const [lootboxReward, setLootboxReward] = useState<LootboxReward | null>(null);
  const [showReward, setShowReward] = useState(false);
  const [showTooltip, setShowTooltip] = useState<string | null>(null);
  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [showLootboxDashboard, setShowLootboxDashboard] = useState(false);
  const [userTier, setUserTier] = useState<'free' | 'silver' | 'gold' | 'platinum'>('silver');
  const [showRitualModal, setShowRitualModal] = useState(false);
  const [selectedRitual, setSelectedRitual] = useState<Ritual | null>(null);
  const [showConfirmSpendModal, setShowConfirmSpendModal] = useState(false);
  const [tokenBalance, setTokenBalance] = useState(240);
  const [gemBalance, setGemBalance] = useState(50);
  const [showPhotoRatingFlow, setShowPhotoRatingFlow] = useState(false);
  const [showDickpicRatingUpsell, setShowDickpicRatingUpsell] = useState(false);
  const [showEnhancedSpinWheel, setShowEnhancedSpinWheel] = useState(false);
  const [showDeepShiftModal, setShowDeepShiftModal] = useState(false);
  const [showFaceShiftModal, setShowFaceShiftModal] = useState(false);
  const {
    openQuestionnaire
  } = useQuestionnaire();
  // Add time remaining indicators
  const [timeUntilDailyRotation, setTimeUntilDailyRotation] = useState<string>('');
  const [timeUntilWeeklyRotation, setTimeUntilWeeklyRotation] = useState<string>('');
  // Last Chance Offers state
  const [lastChanceOffers, setLastChanceOffers] = useState<Array<{
    id: string;
    title: string;
    description: string;
    price: string;
    originalPrice?: string;
    discount?: string;
    expiresAt: number;
    timeRemaining: string;
    type: 'tokens' | 'gems' | 'skin' | 'streak' | 'premium';
    amount: number;
    triggerType: 'daily' | 'weekly' | 'premium' | 'streak';
    imageUrl?: string;
    buttonText: string;
    isNew?: boolean;
  }>>([{
    id: 'offer-1',
    title: 'Token Flash Pack',
    description: 'Get 250 Tokens + 50 Bonus',
    price: '$4.99',
    originalPrice: '$9.99',
    discount: '50% OFF',
    expiresAt: Date.now() + 2 * 60 * 60 * 1000,
    timeRemaining: '01:58:33',
    type: 'tokens',
    amount: 300,
    triggerType: 'daily',
    buttonText: 'Claim Offer',
    isNew: true
  }, {
    id: 'offer-2',
    title: 'Angel Skin Bundle',
    description: 'Unlock 3 Premium Angel Skins',
    price: '$14.99',
    originalPrice: '$29.99',
    discount: '50% OFF',
    expiresAt: Date.now() + 24 * 60 * 60 * 1000,
    timeRemaining: '23:58:33',
    type: 'skin',
    amount: 3,
    triggerType: 'weekly',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gPbfjPdLfzNbqrZitYWXeS/MiaKhalifa.jpg',
    buttonText: 'View Bundle'
  }]);
  // Track mood board updates
  const [moodboardUpdated, setMoodboardUpdated] = useState(false);
  // Calculate time until next rotation
  useEffect(() => {
    const updateRotationTimers = () => {
      const now = Date.now();
      const oneDayMs = 24 * 60 * 60 * 1000;
      const oneWeekMs = 7 * oneDayMs;
      // Daily rotation timer
      const dailyTimeRemaining = lastDailyRotation + oneDayMs - now;
      const dailyHours = Math.floor(dailyTimeRemaining / (60 * 60 * 1000));
      const dailyMinutes = Math.floor(dailyTimeRemaining % (60 * 60 * 1000) / (60 * 1000));
      setTimeUntilDailyRotation(`${dailyHours}h ${dailyMinutes}m`);
      // Weekly rotation timer
      const weeklyTimeRemaining = lastWeeklyRotation + oneWeekMs - now;
      const weeklyDays = Math.floor(weeklyTimeRemaining / oneDayMs);
      const weeklyHours = Math.floor(weeklyTimeRemaining % oneDayMs / (60 * 60 * 1000));
      setTimeUntilWeeklyRotation(`${weeklyDays}d ${weeklyHours}h`);
      // Update Last Chance Offers countdown timers
      setLastChanceOffers(prev => prev.map(offer => {
        const msRemaining = offer.expiresAt - now;
        if (msRemaining <= 0) {
          // Offer expired - could be filtered out later
          return {
            ...offer,
            timeRemaining: 'EXPIRED'
          };
        }
        const hours = Math.floor(msRemaining / (60 * 60 * 1000));
        const minutes = Math.floor(msRemaining % (60 * 60 * 1000) / (60 * 1000));
        const seconds = Math.floor(msRemaining % (60 * 1000) / 1000);
        return {
          ...offer,
          timeRemaining: `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        };
      }).filter(offer => offer.timeRemaining !== 'EXPIRED'));
    };
    updateRotationTimers();
    const timerInterval = setInterval(updateRotationTimers, 1000); // Update every second for countdown accuracy
    return () => {
      clearInterval(timerInterval);
    };
  }, [lastDailyRotation, lastWeeklyRotation, lastChanceOffers]);
  // Add event listener to handle tab changes from other components
  useEffect(() => {
    const handleSetRitualTab = (event: CustomEvent) => {
      if (event.detail && event.detail.tab) {
        setActiveTab(event.detail.tab);
      }
    };
    document.addEventListener('setRitualTab', handleSetRitualTab as EventListener);
    return () => {
      document.removeEventListener('setRitalTab', handleSetRitualTab as EventListener);
    };
  }, []);
  // Update Moodboard after rituals change
  useEffect(() => {
    const updateMoodboard = () => {
      // This would trigger an update to the Moodboard section with the newest ritual set
      // For now, we'll just set a flag to indicate it's been updated
      setMoodboardUpdated(true);
      // Dispatch an event that could be listened to by a Moodboard component
      const event = new CustomEvent('updateMoodboard', {
        detail: {
          dailyRituals,
          funRituals,
          weeklyRituals,
          premiumRituals
        }
      });
      document.dispatchEvent(event);
      // Reset the flag after a short delay
      setTimeout(() => {
        setMoodboardUpdated(false);
      }, 3000);
    };
    updateMoodboard();
  }, [dailyRituals, funRituals, weeklyRituals, premiumRituals]);
  // Helper function to map icon names to Lucide components
  const getIconComponent = (iconName: string, size: number = 20) => {
    const iconMap: Record<string, React.ReactNode> = {
      LogIn: <LogIn size={size} data-id="element-17726" />,
      Calendar: <Calendar size={size} data-id="element-17727" />,
      User: <User size={size} data-id="element-17728" />,
      Users: <Users size={size} data-id="element-17729" />,
      Crown: <Crown size={size} data-id="element-17730" />,
      MessageSquare: <MessageSquare size={size} data-id="element-17731" />,
      MessageCircle: <MessageCircle size={size} data-id="element-17732" />,
      Image: <Image size={size} data-id="element-17733" />,
      ThumbsUp: <Heart size={size} data-id="element-17734" />,
      Heart: <Heart size={size} data-id="element-17735" />,
      BarChart2: <BarChart2 size={size} data-id="element-17736" />,
      Star: <Star size={size} data-id="element-17737" />,
      Bookmark: <Bookmark size={size} data-id="element-17738" />,
      Gift: <Gift size={size} data-id="element-17739" />,
      Palette: <Palette size={size} data-id="element-17740" />,
      Glasses: <Glasses size={size} data-id="element-17741" />,
      Sparkles: <Sparkles size={size} data-id="element-17742" />,
      ClipboardList: <ClipboardList size={size} data-id="element-17743" />,
      Play: <Play size={size} data-id="element-17744" />,
      Gamepad2: <Gamepad2 size={size} data-id="element-17745" />,
      Trophy: <Trophy size={size} data-id="element-17746" />,
      Flame: <Flame size={size} data-id="element-17747" />,
      Package: <Package size={size} data-id="element-17748" />,
      Coins: <Coins size={size} data-id="element-17749" />,
      Video: <Video size={size} data-id="element-17750" />,
      Camera: <Camera size={size} data-id="element-17751" />,
      Zap: <Zap size={size} data-id="element-17752" />,
      UserPlus: <UserPlus size={size} data-id="element-17753" />,
      Award: <Award size={size} data-id="element-17754" />,
      Share2: <Share2 size={size} data-id="element-17755" />,
      Ticket: <Ticket size={size} data-id="element-17756" />,
      CheckCircle: <CheckCircle size={size} data-id="element-17757" />,
      FileText: <FileText size={size} data-id="element-17758" />,
      Sticker: <Sticker size={size} data-id="element-17759" />,
      Laugh: <Laugh size={size} data-id="element-17760" />,
      Theater: <Theater size={size} data-id="element-17761" />,
      Film: <Film size={size} data-id="element-17762" />,
      Music: <Music size={size} data-id="element-17763" />,
      ListMusic: <ListMusic size={size} data-id="element-17764" />,
      HelpCircle: <HelpCircle size={size} data-id="element-17765" />,
      Shuffle: <Shuffle size={size} data-id="element-17766" />,
      CheckCircle2: <CheckCircle2 size={size} data-id="element-17767" />,
      Brain: <Brain size={size} data-id="element-17768" />,
      Shirt: <Shirt size={size} data-id="element-17769" />,
      Diamond: <Diamond size={size} data-id="element-17770" />,
      X: <X size={size} data-id="element-17771" />,
      Wand2: <Wand2 size={size} data-id="element-17772" />,
      ImagePlus: <ImagePlus size={size} data-id="element-17773" />,
      Smile: <Smile size={size} data-id="element-17774" />,
      PartyPopper: <PartyPopper size={size} data-id="element-17775" />,
      Brush: <Brush size={size} data-id="element-17776" />,
      Scissors: <Scissors size={size} data-id="element-17777" />,
      PersonStanding: <PersonStanding size={size} data-id="element-17778" />,
      Scan: <Scan size={size} data-id="element-17779" />,
      ScanFace: <ScanFace size={size} data-id="element-17780" />
    };
    return iconMap[iconName] || <Sparkles size={size} data-id="element-17781" />;
  };
  // New function to render the Last Chance Offers section
  const renderLastChanceOffers = () => {
    if (lastChanceOffers.length === 0) {
      return <div className="mb-6" data-id="element-17782">
          <div className="flex items-center justify-between mb-4" data-id="element-17783">
            <h3 className="text-lg font-bold dark:text-white flex items-center gap-2" data-id="element-17784">
              <span className="text-amber-500" data-id="element-17785">⏳</span> Last Chance Offers
            </h3>
          </div>
          <div className="p-4 bg-gradient-to-r from-gray-100 to-gray-50 dark:from-gray-900 dark:to-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 text-center" data-id="element-17786">
            <p className="text-gray-600 dark:text-gray-400 text-sm" data-id="element-17787">
              Complete Rituals to unlock special time-limited rewards
            </p>
            <div className="mt-2 flex justify-center" data-id="element-17788">
              <div className="inline-flex items-center gap-1 text-xs text-gray-500 dark:text-gray-500 bg-gray-200/50 dark:bg-gray-800/50 rounded-full px-2 py-1" data-id="element-17789">
                <Clock size={12} data-id="element-17790" />
                <span data-id="element-17791">Offers refresh with ritual completions</span>
              </div>
            </div>
          </div>
        </div>;
    }
    return <div className="mb-6" data-id="element-17792">
        <div className="flex items-center justify-between mb-4" data-id="element-17793">
          <h3 className="text-lg font-bold dark:text-white flex items-center gap-2 relative" data-id="element-17794">
            <span className="text-amber-500" data-id="element-17795">⏳</span>
            <span className="relative" data-id="element-17796">
              Last Chance Offers
              <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-17797"></span>
            </span>
          </h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-17798">
          {lastChanceOffers.map(offer => <div key={offer.id} className="relative overflow-hidden rounded-xl border border-amber-500/30 dark:border-amber-700/30 bg-gradient-to-br from-amber-900/10 to-orange-900/5 dark:from-amber-900/20 dark:to-orange-900/10 shadow-md hover:shadow-lg transition-shadow duration-300 backdrop-blur-sm" data-id="element-17799">
              {offer.discount && <div className="absolute -right-8 -top-8 w-24 h-24 flex items-center justify-center" data-id="element-17800">
                  <div className="absolute inset-0 bg-red-500 opacity-90 rotate-45" data-id="element-17801"></div>
                  <div className="relative transform rotate-45 text-white text-xs font-bold py-1 px-2 mt-10 ml-2" data-id="element-17802">
                    {offer.discount}
                  </div>
                </div>}
              {offer.isNew && <div className="absolute left-3 top-3 bg-blue-500 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-17803">
                  NEW
                </div>}
              <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-amber-500 to-red-500" data-id="element-17804"></div>
              <div className="p-4" data-id="element-17805">
                <div className="flex items-start gap-3" data-id="element-17806">
                  <div className="relative w-16 h-16 flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-amber-500 to-red-500 rounded-lg overflow-hidden shadow-[0_0_15px_rgba(251,191,36,0.3)] dark:shadow-[0_0_15px_rgba(251,191,36,0.4)]" data-id="element-17807">
                    <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')] opacity-30" data-id="element-17808"></div>
                    {offer.type === 'tokens' && <Coins size={24} className="text-white" data-id="element-17809" />}
                    {offer.type === 'gems' && <Diamond size={24} className="text-white" data-id="element-17810" />}
                    {offer.type === 'skin' && (offer.imageUrl ? <img src={offer.imageUrl} alt="Skin" className="w-full h-full object-cover" data-id="element-17811" /> : <Sparkles size={24} className="text-white" data-id="element-17812" />)}
                    {offer.type === 'streak' && <Flame size={24} className="text-white" data-id="element-17813" />}
                    {offer.type === 'premium' && <Crown size={24} className="text-white" data-id="element-17814" />}
                  </div>
                  <div className="flex-1" data-id="element-17815">
                    <div className="flex items-start justify-between" data-id="element-17816">
                      <div data-id="element-17817">
                        <h4 className="font-medium dark:text-white" data-id="element-17818">
                          {offer.title}
                        </h4>
                        <p className="text-xs text-gray-600 dark:text-gray-400" data-id="element-17819">
                          {offer.description}
                        </p>
                      </div>
                    </div>
                    <div className="mt-2 flex items-center justify-between" data-id="element-17820">
                      <div className="flex items-center gap-2" data-id="element-17821">
                        <span className="text-lg font-bold text-amber-600 dark:text-amber-400" data-id="element-17822">
                          {offer.price}
                        </span>
                        {offer.originalPrice && <span className="text-xs text-gray-500 dark:text-gray-500 line-through" data-id="element-17823">
                            {offer.originalPrice}
                          </span>}
                      </div>
                      <div className="flex items-center gap-1 px-2 py-0.5 bg-red-900/20 dark:bg-red-900/30 border border-red-500/30 dark:border-red-800/30 rounded-full text-xs text-red-600 dark:text-red-400" data-id="element-17824">
                        <Clock size={12} data-id="element-17825" />
                        <span className="font-mono" data-id="element-17826">{offer.timeRemaining}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <button onClick={() => handleSelectOffer(offer.id)} className="w-full py-2 mt-3 bg-gradient-to-r from-amber-500 to-red-500 hover:from-amber-600 hover:to-red-600 text-white rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2 shadow-[0_0_10px_rgba(251,191,36,0.2)] hover:shadow-[0_0_15px_rgba(251,191,36,0.3)]" data-id="element-17827">
                  {offer.buttonText}
                  <ArrowRight size={14} data-id="element-17828" />
                </button>
              </div>
            </div>)}
        </div>
      </div>;
  };
  // Function to handle offer selection
  const handleSelectOffer = (offerId: string) => {
    // Navigate to token store with the offer highlighted
    const event = new CustomEvent('navigate', {
      detail: {
        section: 'token_wallet',
        highlight: offerId
      }
    });
    document.dispatchEvent(event);
  };
  // Function to handle ritual action click
  const handleRitualAction = (ritual: Ritual) => {
    // Set the selected ritual for any modals that might need it
    setSelectedRitual(ritual);
    // Get lowercase versions of title and description for easier matching
    const ritualTitle = ritual.title.toLowerCase();
    const ritualDesc = ritual.description.toLowerCase();
    // Handle DeepShift rituals
    if (ritualTitle.includes('deepshift') || ritualDesc.includes('deepshift') || ritualTitle.includes('deep shift') || ritualDesc.includes('deep shift') || ritualTitle.includes('fantasy') && ritualTitle.includes('scenario') || ritualDesc.includes('fantasy') && ritualDesc.includes('scenario')) {
      // Open DeepShift modal
      const deepShiftEvent = new CustomEvent('openDeepShiftModal', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(deepShiftEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening DeepShift Creator', {
        description: 'Create your fantasy scenario',
        duration: 3000
      });
      return;
    }
    // Handle FaceShift rituals
    if (ritualTitle.includes('faceshift') || ritualDesc.includes('faceshift') || ritualTitle.includes('face shift') || ritualDesc.includes('face shift') || ritualTitle.includes('swap') && ritualTitle.includes('face') || ritualDesc.includes('swap') && ritualDesc.includes('face')) {
      // Open FaceShift modal
      const faceShiftEvent = new CustomEvent('openFaceShiftModal', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(faceShiftEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening FaceShift Creator', {
        description: 'Swap faces with your favorite angel',
        duration: 3000
      });
      return;
    }
    // Check if this is a verification ritual
    if (ritualTitle.includes('verify') || ritualDesc.includes('verify') || ritualTitle.includes('verification') || ritualDesc.includes('verification')) {
      // Show age verification modal
      const showVerificationEvent = new CustomEvent('showAgeVerification', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(showVerificationEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, 1);
      // Show success toast
      toast.success('Opening Age Verification', {
        description: 'Please verify your age to continue',
        duration: 3000
      });
      return; // Exit early to prevent further processing
    }
    // Check if this is a wheel or spin ritual (handle this case first)
    const isWheelRitual = ritualTitle.includes('wheel') || ritualTitle.includes('spin') || ritualDesc.includes('wheel') || ritualDesc.includes('spin');
    if (isWheelRitual) {
      // Handle wheel or spin rituals with EnhancedSpinWheel
      setShowEnhancedSpinWheel(true);
      // DO NOT update ritual progress or mark as completed here
      // The ritual should only be completed after the user spins the wheel
      toast.success('Opening Fortune Wheel', {
        description: 'Spin to earn rewards!',
        duration: 3000
      });
      return; // Exit early to prevent further processing
    }
    // Handle profile update rituals
    if (ritualTitle.includes('update') && ritualTitle.includes('profile') || ritualTitle.includes('update') && ritualTitle.includes('bio') || ritualTitle.includes('update') && ritualTitle.includes('picture') || ritualDesc.includes('update') && ritualDesc.includes('profile') || ritualDesc.includes('update') && ritualDesc.includes('bio') || ritualDesc.includes('update') && ritualDesc.includes('picture')) {
      // Open profile settings
      const openProfileEvent = new CustomEvent('openProfileSettings', {
        detail: {
          ritualId: ritual.id,
          tab: ritualTitle.includes('picture') ? 'appearance' : 'general'
        }
      });
      document.dispatchEvent(openProfileEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Profile Settings', {
        description: 'Update your profile information',
        duration: 3000
      });
      return;
    }
    // Handle privacy settings rituals
    if (ritualTitle.includes('privacy') && ritualTitle.includes('settings') || ritualTitle.includes('adjust') && ritualTitle.includes('privacy') || ritualDesc.includes('privacy') && ritualDesc.includes('settings') || ritualDesc.includes('adjust') && ritualDesc.includes('privacy')) {
      // Open profile settings with privacy tab
      const openProfileEvent = new CustomEvent('openProfileSettings', {
        detail: {
          ritualId: ritual.id,
          tab: 'privacy'
        }
      });
      document.dispatchEvent(openProfileEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Privacy Settings', {
        description: 'Adjust your privacy preferences',
        duration: 3000
      });
      return;
    }
    // Handle notification settings rituals
    if (ritualTitle.includes('enable') && ritualTitle.includes('notification') || ritualDesc.includes('enable') && ritualDesc.includes('notification') || ritualTitle.includes('notification') && ritualTitle.includes('settings') || ritualDesc.includes('notification') && ritualDesc.includes('settings')) {
      // Open profile settings with notifications tab
      const openProfileEvent = new CustomEvent('openProfileSettings', {
        detail: {
          ritualId: ritual.id,
          tab: 'notifications'
        }
      });
      document.dispatchEvent(openProfileEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Notification Settings', {
        description: 'Manage your notification preferences',
        duration: 3000
      });
      return;
    }
    // Handle login streak rituals
    if (ritualTitle.includes('login') && (ritualTitle.includes('streak') || ritualTitle.includes('once') || ritualTitle.includes('twice') || ritualTitle.includes('three times')) || ritualDesc.includes('login') && (ritualDesc.includes('streak') || ritualDesc.includes('once') || ritualDesc.includes('twice') || ritualDesc.includes('three times'))) {
      // Highlight login streak in the tracker
      const loginStreakEvent = new CustomEvent('highlightLoginStreak', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(loginStreakEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Login Streak Tracked', {
        description: 'Your login activity has been recorded',
        duration: 3000
      });
      return;
    }
    // Handle favorite/follow Angel rituals
    if (ritualTitle.includes('favorite') && ritualTitle.includes('angel') || ritualTitle.includes('follow') && ritualTitle.includes('angel') || ritualDesc.includes('favorite') && ritualDesc.includes('angel') || ritualDesc.includes('follow') && ritualDesc.includes('angel')) {
      // Navigate to favorites section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'favorites',
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(navigateEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Favorites', {
        description: 'Add Angels to your favorites',
        duration: 3000
      });
      return;
    }
    // Handle claim streak bonus rituals
    if (ritualTitle.includes('claim') && ritualTitle.includes('streak') || ritualDesc.includes('claim') && ritualDesc.includes('streak')) {
      // Open streak bonus claim modal
      const streakEvent = new CustomEvent('openStreakBonusModal', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(streakEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Streak Bonus', {
        description: 'Claim your streak rewards',
        duration: 3000
      });
      return;
    }
    // Handle subscription/membership rituals
    if (ritualTitle.includes('subscription') || ritualTitle.includes('premium') || ritualTitle.includes('vip') || ritualTitle.includes('upgrade') || ritualDesc.includes('subscription') || ritualDesc.includes('premium') || ritualDesc.includes('vip') || ritualDesc.includes('upgrade')) {
      // Navigate to membership section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'subscription',
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(navigateEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Membership Options', {
        description: 'Explore premium features and benefits',
        duration: 3000
      });
      return;
    }
    // Handle token purchase/spend rituals
    if (ritualTitle.includes('purchase') && ritualTitle.includes('token') || ritualTitle.includes('buy') && ritualTitle.includes('token') || ritualDesc.includes('purchase') && ritualDesc.includes('token') || ritualDesc.includes('buy') && ritualDesc.includes('token')) {
      // Open token store
      const tokenEvent = new CustomEvent('openTokenStore', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(tokenEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Token Store', {
        description: 'Purchase tokens for premium features',
        duration: 3000
      });
      return;
    }
    // Handle questionnaire rituals
    if (ritualTitle.includes('questionnaire') || ritualDesc.includes('questionnaire')) {
      // Open questionnaire for questionnaire-related rituals
      openQuestionnaire();
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Questionnaire opened! Complete it to progress on your ritual.', {
        duration: 3000
      });
      return;
    }
    // Handle dickpic rating rituals
    if (ritualTitle.includes('dickpic') || ritualTitle.includes('friends opinion') || ritualDesc.includes('dickpic') || ritualDesc.includes('friends opinion')) {
      // Open dickpic rating flow directly
      setShowPhotoRatingFlow(true);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Photo Rating opened', {
        description: 'Get feedback on your photos',
        duration: 3000
      });
      return;
    }
    // Handle invite/referral rituals
    if (ritualTitle.includes('invite') || ritualDesc.includes('invite') || ritualTitle.includes('refer') || ritualDesc.includes('refer')) {
      // Handle any invite ritual using ReferralModal
      const referralEvent = new CustomEvent('openReferralModal', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(referralEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Referral System', {
        description: 'Invite friends to earn rewards',
        duration: 3000
      });
      return;
    }
    // Handle skin-related rituals
    if (ritualTitle.includes('skin') || ritualDesc.includes('skin') || ritualTitle.includes('dress up') || ritualDesc.includes('dress up') || ritualTitle.includes('outfit') || ritualDesc.includes('outfit')) {
      // Navigate to Angel Skins Shop
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'angel_skins_shop',
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(navigateEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Angel Skins Shop', {
        description: 'Browse and select your favorite skins',
        duration: 3000
      });
      return;
    }
    // Handle bookmarks rituals
    if (ritualTitle.includes('bookmark') || ritualDesc.includes('bookmark')) {
      // Determine bookmark category
      let category = null;
      if (ritualTitle.includes('fan stories') || ritualDesc.includes('fan stories')) {
        category = 'Fan Stories';
      } else if (ritualTitle.includes('poll') || ritualDesc.includes('poll')) {
        category = 'Polls';
      } else if (ritualTitle.includes('fantasy') || ritualDesc.includes('fantasy')) {
        category = 'Fantasy';
      } else if (ritualTitle.includes('playful') || ritualDesc.includes('playful')) {
        category = 'Playful';
      }
      // Navigate to bookmarks section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'bookmarks',
          ritualId: ritual.id,
          category: category
        }
      });
      document.dispatchEvent(navigateEvent);
      // If there's a specific category, also send the category event
      if (category) {
        const categoryEvent = new CustomEvent('setBookmarkCategory', {
          detail: {
            category
          }
        });
        document.dispatchEvent(categoryEvent);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Bookmarks', {
        description: category ? `Viewing ${category} bookmarks` : 'Browse your saved content',
        duration: 3000
      });
      return;
    }
    // Handle lootbox rituals
    if (ritualTitle.includes('lootbox') || ritualDesc.includes('lootbox')) {
      // Determine lootbox type
      if (ritualTitle.includes('jackpot') || ritualDesc.includes('jackpot')) {
        // Open jackpot lootbox
        const jackpotEvent = new CustomEvent('openJackpotLootbox', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(jackpotEvent);
      } else if (ritualTitle.includes('weekly premium') || ritualDesc.includes('weekly premium')) {
        // Open premium lootbox
        const lootboxEvent = new CustomEvent('openPremiumLootbox', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(lootboxEvent);
      } else if (ritualTitle.includes('weekly passion') || ritualDesc.includes('weekly passion')) {
        // Open passion lootbox
        const lootboxEvent = new CustomEvent('openPassionLootbox', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(lootboxEvent);
      } else {
        // Open general lootbox dashboard
        setShowLootboxDashboard(true);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Lootbox', {
        description: 'Claim your rewards',
        duration: 3000
      });
      return;
    }
    // Handle social feed/reaction rituals
    if (ritualTitle.includes('sparkle') && ritualTitle.includes('react') || ritualDesc.includes('sparkle') && ritualDesc.includes('react') || ritualTitle.includes('sparkle reaction') || ritualDesc.includes('sparkle reaction') || ritualTitle.includes('emoji') && ritualTitle.includes('reaction') || ritualDesc.includes('emoji') && ritualDesc.includes('reaction') || ritualTitle.includes('diamond') && ritualTitle.includes('react') || ritualDesc.includes('diamond') && ritualDesc.includes('react') || ritualTitle.includes('gif') && ritualTitle.includes('feed') || ritualDesc.includes('gif') && ritualDesc.includes('feed') || ritualTitle.includes("friends' posts") || ritualDesc.includes("friends' posts") || ritualTitle.includes('fun photo feed') || ritualDesc.includes('fun photo feed')) {
      // Navigate to social feed
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'social_feed',
          profile: 'customer'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Dispatch specific reaction event if needed
      if (ritualTitle.includes('sparkle') || ritualDesc.includes('sparkle')) {
        const reactEvent = new CustomEvent('showSparkleReactions', {});
        document.dispatchEvent(reactEvent);
      } else if (ritualTitle.includes('diamond') || ritualDesc.includes('diamond')) {
        const reactEvent = new CustomEvent('showDiamondReactions', {});
        document.dispatchEvent(reactEvent);
      } else if (ritualTitle.includes('gif') || ritualDesc.includes('gif')) {
        const reactEvent = new CustomEvent('showGifPosting', {});
        document.dispatchEvent(reactEvent);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Social Feed', {
        description: 'Interact with posts and friends',
        duration: 3000
      });
      return;
    }
    // Handle social posting rituals
    if (ritualTitle.includes('post') && ritualTitle.includes('update') || ritualDesc.includes('post') && ritualDesc.includes('update') || ritualTitle.includes('create post') || ritualDesc.includes('create post')) {
      // Navigate to social feed
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'social_feed',
          profile: 'customer'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Show posting interface
      const postEvent = new CustomEvent('showPostingInterface', {});
      document.dispatchEvent(postEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Posting Interface', {
        description: 'Create a new post',
        duration: 3000
      });
      return;
    }
    // Handle poll rituals
    if (ritualTitle.includes('poll') && ritualTitle.includes('vote') || ritualDesc.includes('poll') && ritualDesc.includes('vote') || ritualTitle.includes('trending poll') || ritualDesc.includes('trending poll') || ritualTitle.includes('pollfeed') || ritualDesc.includes('pollfeed')) {
      // Open poll feed
      const pollFeedEvent = new CustomEvent('openPollFeed', {
        detail: {
          ritualId: ritual.id,
          trending: ritualTitle.includes('trending') || ritualDesc.includes('trending')
        }
      });
      document.dispatchEvent(pollFeedEvent);
      // Navigate to social polls section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'social_polls'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Poll Feed', {
        description: 'Vote on trending polls',
        duration: 3000
      });
      return;
    }
    // Handle poll creation rituals
    if (ritualTitle.includes('poll') && ritualTitle.includes('create') || ritualDesc.includes('poll') && ritualDesc.includes('create') || ritualTitle.includes('custom poll') || ritualDesc.includes('custom poll') || ritualTitle.includes('kink') && ritualTitle.includes('poll') || ritualDesc.includes('kink') && ritualDesc.includes('poll') || ritualTitle.includes('pollgenerator') || ritualDesc.includes('pollgenerator')) {
      // Open poll generator
      const pollEvent = new CustomEvent('openPollGenerator', {
        detail: {
          ritualId: ritual.id,
          kinkMode: ritualTitle.includes('kink') || ritualDesc.includes('kink')
        }
      });
      document.dispatchEvent(pollEvent);
      // Navigate to social polls section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'social_polls'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Poll Generator', {
        description: 'Create your own custom poll',
        duration: 3000
      });
      return;
    }
    // Handle Hot or Not rituals
    if (ritualTitle.includes('hot or not') || ritualDesc.includes('hot or not') || ritualTitle.includes('hotornot') || ritualDesc.includes('hotornot') || ritualTitle.includes('selfie') && ritualTitle.includes('rate') || ritualDesc.includes('selfie') && ritualDesc.includes('rate')) {
      // Navigate to Hot or Not section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'hot_or_not'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Hot or Not', {
        description: 'Rate and get rated',
        duration: 3000
      });
      return;
    }
    // Handle chat/message rituals
    if (ritualTitle.includes('sticker') && ritualTitle.includes('chat') || ritualDesc.includes('sticker') && ritualDesc.includes('chat') || ritualTitle.includes('voice note') || ritualDesc.includes('voice note') || ritualTitle.includes('audio effect') || ritualDesc.includes('audio effect') || ritualTitle.includes('private fun chat') || ritualDesc.includes('private fun chat') || ritualTitle.includes('nickname') || ritualDesc.includes('nickname')) {
      // Navigate to chat section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'chat'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Dispatch specific events based on subflow
      if (ritualTitle.includes('sticker') || ritualDesc.includes('sticker')) {
        const stickerEvent = new CustomEvent('openStickerInterface', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(stickerEvent);
      } else if (ritualTitle.includes('voice') || ritualDesc.includes('voice') || ritualTitle.includes('audio') || ritualDesc.includes('audio')) {
        const voiceEvent = new CustomEvent('openVoiceInterface', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(voiceEvent);
      } else if (ritualTitle.includes('nickname') || ritualDesc.includes('nickname')) {
        const nicknameEvent = new CustomEvent('openNicknameInterface', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(nicknameEvent);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Chat', {
        description: 'Connect with your favorite angels',
        duration: 3000
      });
      return;
    }
    // Handle playroom/group chat rituals
    if (ritualTitle.includes('playroom') || ritualDesc.includes('playroom') || ritualTitle.includes('group chat') || ritualDesc.includes('group chat') || ritualTitle.includes('multi-angel') && ritualTitle.includes('chat') || ritualDesc.includes('multi-angel') && ritualDesc.includes('chat')) {
      // Navigate to group chat section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'group_chat'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Handle specific playroom types
      if (ritualTitle.includes('multi-angel') && ritualTitle.includes('playroom') || ritualDesc.includes('multi-angel') && ritualDesc.includes('playroom') || ritualTitle.includes('playroom with 2 angels') || ritualDesc.includes('playroom with 2 angels')) {
        const multiAngelEvent = new CustomEvent('startMultiAngelChat', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(multiAngelEvent);
      } else if (ritualTitle.includes('comment') && ritualTitle.includes('playroom') || ritualDesc.includes('comment') && ritualDesc.includes('playroom')) {
        // Comment in playroom
        const commentEvent = new CustomEvent('openPlayroomComment', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(commentEvent);
      } else if (ritualTitle.includes('save') && ritualTitle.includes('playroom') || ritualDesc.includes('save') && ritualDesc.includes('playroom')) {
        // Save playroom
        const saveEvent = new CustomEvent('openPlayroomSave', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(saveEvent);
      } else if (ritualTitle.includes('sticker') && ritualTitle.includes('group chat') || ritualDesc.includes('sticker') && ritualDesc.includes('group chat')) {
        // Group chat stickers
        const stickerEvent = new CustomEvent('openGroupStickerInterface', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(stickerEvent);
      } else if (ritualTitle.includes('playroom') && ritualTitle.includes('30 minutes') || ritualDesc.includes('playroom') && ritualDesc.includes('30 minutes')) {
        // Timed playroom
        const timedEvent = new CustomEvent('startTimedPlayroom', {
          detail: {
            ritualId: ritual.id,
            duration: 30
          }
        });
        document.dispatchEvent(timedEvent);
      } else if (ritualTitle.includes('premium') && ritualTitle.includes('playroom') && ritualTitle.includes('event') || ritualDesc.includes('premium') && ritualDesc.includes('playroom') && ritualDesc.includes('event')) {
        // Premium playroom event
        const premiumEvent = new CustomEvent('startPremiumPlayroomEvent', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(premiumEvent);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Group Chat', {
        description: 'Join the playroom fun',
        duration: 3000
      });
      return;
    }
    // Handle live cam / tease preview rituals
    if (ritualTitle.includes('live angel teaser') || ritualDesc.includes('live angel teaser') || ritualTitle.includes('teasepreviewmodal') || ritualDesc.includes('teasepreviewmodal') || ritualTitle.includes('livecam') || ritualDesc.includes('livecam')) {
      if (ritualTitle.includes('teasepreviewmodal') || ritualDesc.includes('teasepreviewmodal')) {
        // Open tease preview
        const teaseEvent = new CustomEvent('openTeasePreview', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(teaseEvent);
      } else {
        // Navigate to live cam section
        const navigateEvent = new CustomEvent('navigate', {
          detail: {
            section: 'live_cam'
          }
        });
        document.dispatchEvent(navigateEvent);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Live Cam', {
        description: 'Watch live angel teasers',
        duration: 3000
      });
      return;
    }
    // Handle VR/AR rituals
    if (ritualTitle.includes('ar filter') || ritualDesc.includes('ar filter') || ritualTitle.includes('vr environment') || ritualDesc.includes('vr environment') || ritualTitle.includes('teaser clip ar/vr') || ritualDesc.includes('teaser clip ar/vr') || ritualTitle.includes('ar emoji') || ritualDesc.includes('ar emoji') || ritualTitle.includes('vr demo') || ritualDesc.includes('vr demo') || ritualTitle.includes('ar/vr playroom demo') || ritualDesc.includes('ar/vr playroom demo') || ritualTitle.includes('vr message') || ritualDesc.includes('vr message')) {
      // Navigate to VR/AR section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'vr_ar'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Dispatch specific events based on VR/AR subflow
      if (ritualTitle.includes('teaser') || ritualDesc.includes('teaser')) {
        const teaserEvent = new CustomEvent('openVRARTeaser', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(teaserEvent);
      } else if (ritualTitle.includes('demo') || ritualDesc.includes('demo')) {
        const demoEvent = new CustomEvent('openVRARDemo', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(demoEvent);
      } else if (ritualTitle.includes('playroom') || ritualDesc.includes('playroom')) {
        const playroomEvent = new CustomEvent('openVRARPlayroom', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(playroomEvent);
      } else if (ritualTitle.includes('message') || ritualDesc.includes('message')) {
        const messageEvent = new CustomEvent('openVRARMessage', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(messageEvent);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening VR/AR Experience', {
        description: 'Explore immersive content',
        duration: 3000
      });
      return;
    }
    // Handle fantasy/scenario rituals
    if (ritualTitle.includes('fantasy') || ritualDesc.includes('fantasy') || ritualTitle.includes('scenariowizard') || ritualDesc.includes('scenariowizard') || ritualTitle.includes('fantasy scenarios') && ritualTitle.includes('rate') || ritualDesc.includes('fantasy scenarios') && ritualDesc.includes('rate')) {
      // Navigate to unleash section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'unleash'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Dispatch specific events for premium or rating flows
      if (ritualTitle.includes('premium') || ritualDesc.includes('premium')) {
        const premiumEvent = new CustomEvent('startPremiumScenario', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(premiumEvent);
      } else if (ritualTitle.includes('rate') || ritualDesc.includes('rate')) {
        const ratingEvent = new CustomEvent('startScenarioRating', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(ratingEvent);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Fantasy Scenario', {
        description: 'Create your personalized fantasy',
        duration: 3000
      });
      return;
    }
    // Handle angel social feed rituals
    if (ritualTitle.includes('comment') && ritualTitle.includes('angel') || ritualDesc.includes('comment') && ritualDesc.includes('angel') || ritualTitle.includes('angel feeds') || ritualDesc.includes('angel feeds')) {
      // Navigate to discovery feed or twitter profile
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'discovery_feed'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Angel Discovery', {
        description: 'Browse and interact with angel feeds',
        duration: 3000
      });
      return;
    }
    // Handle games section rituals
    if (ritualTitle.includes('gamessection') || ritualDesc.includes('gamessection') || ritualTitle.includes('play game') || ritualDesc.includes('play game') || ritualTitle.includes('minigame') || ritualDesc.includes('minigame')) {
      // Navigate to games section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'games'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Games Section', {
        description: 'Play fun mini-games',
        duration: 3000
      });
      return;
    }
    // Handle angel match game rituals
    if (ritualTitle.includes('angel match') || ritualDesc.includes('angel match')) {
      // Navigate to angel match game
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'angel_match'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Angel Match Game', {
        description: 'Play the matching game with angels',
        duration: 3000
      });
      return;
    }
    // Handle premium content rituals
    if (ritualTitle.includes('premium content') || ritualDesc.includes('premium content') || ritualTitle.includes('sticker') && ritualTitle.includes('pack') || ritualDesc.includes('sticker') && ritualDesc.includes('pack') || ritualTitle.includes('roses') && !ritualTitle.includes('gift') || ritualDesc.includes('roses') && !ritualDesc.includes('gift') || ritualTitle.includes('digital') && ritualTitle.includes('hug') || ritualDesc.includes('digital') && ritualDesc.includes('hug') || ritualTitle.includes('sparkle') && ritualTitle.includes('gift') || ritualDesc.includes('sparkle') && ritualDesc.includes('gift')) {
      // Navigate to premium content section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'premium'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Dispatch event for specific premium content type
      if (ritualTitle.includes('sticker') && ritualTitle.includes('pack') || ritualDesc.includes('sticker') && ritualDesc.includes('pack')) {
        const stickerEvent = new CustomEvent('openStickerPackUpsell', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(stickerEvent);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Premium Content', {
        description: 'Explore exclusive premium content',
        duration: 3000
      });
      return;
    }
    // Handle upsell rituals
    if (ritualTitle.includes('ai image') || ritualDesc.includes('ai image') || ritualTitle.includes('premium video') || ritualDesc.includes('premium video') || ritualTitle.includes('supplement gift') || ritualDesc.includes('supplement gift') || ritualTitle.includes('toysupsell') || ritualDesc.includes('toysupsell')) {
      // Dispatch specific upsell events
      if (ritualTitle.includes('ai image') || ritualDesc.includes('ai image')) {
        const imageEvent = new CustomEvent('openImageGenerationUpsell', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(imageEvent);
      } else if (ritualTitle.includes('premium video') || ritualDesc.includes('premium video')) {
        const videoEvent = new CustomEvent('openVideoGenerationUpsell', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(videoEvent);
      } else if (ritualTitle.includes('supplement') || ritualDesc.includes('supplement')) {
        const supplementEvent = new CustomEvent('openSupplementUpsell', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(supplementEvent);
      } else if (ritualTitle.includes('toysupsell') || ritualDesc.includes('toysupsell')) {
        const toysEvent = new CustomEvent('openToysUpsell', {
          detail: {
            ritualId: ritual.id,
            demoMode: ritualTitle.includes('demo') || ritualDesc.includes('demo')
          }
        });
        document.dispatchEvent(toysEvent);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Premium Upsell', {
        description: 'Explore premium features and content',
        duration: 3000
      });
      return;
    }
    // Handle gift rituals
    if (ritualTitle.includes('gift') && ritualTitle.includes('angel') || ritualDesc.includes('gift') && ritualDesc.includes('angel')) {
      // Navigate to premium section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'premium'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Open gift subflow
      const giftEvent = new CustomEvent('openGiftSubflow', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(giftEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Gift Selection', {
        description: 'Send gifts to your favorite angels',
        duration: 3000
      });
      return;
    }
    // Handle fanclub rituals
    if (ritualTitle.includes('fanclub') || ritualDesc.includes('fanclub')) {
      // Navigate to fanclub section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'fanclub'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Dispatch specific events based on fanclub subflow
      if (ritualTitle.includes('react') && ritualTitle.includes('fanclub') || ritualDesc.includes('react') && ritualDesc.includes('fanclub')) {
        const reactEvent = new CustomEvent('showFanclubReactions', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(reactEvent);
      } else if (ritualTitle.includes('gift') && ritualTitle.includes('fanclub') || ritualDesc.includes('gift') && ritualDesc.includes('fanclub')) {
        const giftEvent = new CustomEvent('showFanclubGifts', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(giftEvent);
      } else if (ritualTitle.includes('multi-angel') && ritualTitle.includes('fanclub') && ritualTitle.includes('chat') || ritualDesc.includes('multi-angel') && ritualDesc.includes('fanclub') && ritualDesc.includes('chat')) {
        const chatEvent = new CustomEvent('startMultiAngelFanclubChat', {
          detail: {
            ritualId: ritual.id
          }
        });
        document.dispatchEvent(chatEvent);
      }
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Fanclub', {
        description: 'Explore celebrity AI angels',
        duration: 3000
      });
      return;
    }
    // Handle voice AI rituals
    if (ritualTitle.includes('personalized voice') || ritualDesc.includes('personalized voice') || ritualTitle.includes('voice ai') || ritualDesc.includes('voice ai')) {
      // Activate voice AI
      const voiceEvent = new CustomEvent('activateVoiceAI', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(voiceEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Activating Voice AI', {
        description: 'Experience personalized voice interactions',
        duration: 3000
      });
      return;
    }
    // Handle badge rituals
    if (ritualTitle.includes('sparkle badge') || ritualDesc.includes('sparkle badge') || ritualTitle.includes('badge') || ritualDesc.includes('badge')) {
      // Navigate to rewards section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'rewards'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Show sparkle badge
      const badgeEvent = new CustomEvent('showSparkleBadge', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(badgeEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Badge Collection', {
        description: 'View your earned badges',
        duration: 3000
      });
      return;
    }
    // Handle reward hub rituals
    if (ritualTitle.includes('claim reward') || ritualDesc.includes('claim reward') || ritualTitle.includes('rewardhub') && ritualTitle.includes('claim') || ritualDesc.includes('rewardhub') && ritualDesc.includes('claim') || ritualTitle.includes('ritualrewards') || ritualDesc.includes('ritualrewards')) {
      // Navigate to rewards section
      const navigateEvent = new CustomEvent('navigate', {
        detail: {
          section: 'rewards'
        }
      });
      document.dispatchEvent(navigateEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Reward Hub', {
        description: 'Claim your earned rewards',
        duration: 3000
      });
      return;
    }
    // For premium rituals that don't match any specific category, show confirmation modal for spending
    if (ritual.premiumOnly || ritual.requiredForLootbox) {
      setShowConfirmSpendModal(true);
      return;
    }
    // If we've reached this point, we don't have a specific handler for this ritual
    // Let's try to map it to a component based on its category
    const componentMapping = getRitualComponentMapping(ritual);
    if (componentMapping) {
      // If we have a component mapping, navigate to it
      navigateToComponent(componentMapping, ritual);
    } else {
      // If no component mapping exists, show a toast and update progress anyway
      toast.info(`Starting ritual: ${ritual.title}`, {
        description: 'Progress will be tracked',
        duration: 3000
      });
      // Update ritual progress for unhandled rituals
      updateRitualProgress(ritual.id, ritual.progress + 1);
    }
  };
  // Function to handle spending tokens/gems for premium rituals
  const handlePremiumSpend = () => {
    if (!selectedRitual) return;
    // Determine cost based on ritual
    let tokenCost = 0;
    let gemCost = 0;
    // Set costs based on ritual category and type
    if (selectedRitual.category === 'unleash') {
      gemCost = 25;
    } else if (selectedRitual.category === 'media') {
      if (selectedRitual.title.includes('video')) {
        gemCost = 50;
      } else {
        gemCost = 20;
      }
    } else if (selectedRitual.category === 'dickpic') {
      tokenCost = 30;
    } else if (selectedRitual.category === 'playroom') {
      tokenCost = 40;
    } else if (selectedRitual.category === 'marketplace') {
      if (selectedRitual.title.includes('skin')) {
        gemCost = 30;
      } else {
        tokenCost = 25;
      }
    } else {
      // Default costs
      tokenCost = 15;
    }
    // Check if user has enough tokens/gems
    if (tokenCost > tokenBalance) {
      toast.error('Not enough LuvTokens', {
        description: `You need ${tokenCost} LuvTokens to complete this ritual.`,
        action: {
          label: 'Get Tokens',
          onClick: () => {
            const event = new CustomEvent('navigate', {
              detail: {
                section: 'token_wallet'
              }
            });
            document.dispatchEvent(event);
          }
        }
      });
      setShowConfirmSpendModal(false);
      return;
    }
    if (gemCost > gemBalance) {
      toast.error('Not enough Gems', {
        description: `You need ${gemCost} Gems to complete this ritual.`,
        action: {
          label: 'Get Gems',
          onClick: () => {
            const event = new CustomEvent('navigate', {
              detail: {
                section: 'token_wallet'
              }
            });
            document.dispatchEvent(event);
          }
        }
      });
      setShowConfirmSpendModal(false);
      return;
    }
    // Deduct tokens/gems
    if (tokenCost > 0) {
      setTokenBalance(prev => prev - tokenCost);
    }
    if (gemCost > 0) {
      setGemBalance(prev => prev - gemCost);
    }
    // Navigate to component
    const componentMapping = getRitualComponentMapping(selectedRitual);
    navigateToComponent(componentMapping, selectedRitual);
    // Show toast for spending
    if (tokenCost > 0) {
      toast.success(`Spent ${tokenCost} LuvTokens`, {
        description: `You've unlocked premium content for "${selectedRitual.title}"`
      });
    } else if (gemCost > 0) {
      toast.success(`Spent ${gemCost} Gems`, {
        description: `You've unlocked premium content for "${selectedRitual.title}"`
      });
    }
    // Update stats
    updateStats('tokens_spent', tokenCost);
    updateStats('gems_spent', gemCost);
    // Add transaction to reward hub
    addToRewardHub({
      type: tokenCost > 0 ? 'tokens' : 'gems',
      name: `Premium Content: ${selectedRitual.title}`,
      amount: -(tokenCost > 0 ? tokenCost : gemCost),
      timestamp: Date.now()
    });
    // Close modal
    setShowConfirmSpendModal(false);
  };
  // Function to complete ritual from modal
  const completeRitualFromModal = (ritualId: string) => {
    // Find the ritual
    const ritual = dailyRituals.concat(weeklyRituals, funRituals, premiumRituals).find(r => r.id === ritualId);
    if (ritual) {
      // Check if it's a wheel ritual - these should NOT be auto-completed
      const ritualTitle = ritual.title.toLowerCase();
      const ritualDesc = ritual.description.toLowerCase();
      const isWheelRitual = ritualTitle.includes('wheel') || ritualTitle.includes('spin') || ritualDesc.includes('wheel') || ritualDesc.includes('spin');
      if (isWheelRitual) {
        // For wheel rituals, we should only mark it complete after the user has actually spun the wheel
        // This should be handled in the EnhancedSpinWheel component's onRewardClaimed callback
        return;
      }
      // For non-wheel rituals, proceed with completion
      updateRitualProgress(ritualId, ritual.progress + 1);
      if (ritual.progress + 1 >= ritual.required) {
        // Ritual completed
        completeRitual(ritualId);
        // Show success toast
        toast.success(`Ritual Completed: ${ritual.title}`, {
          description: 'You earned rewards!',
          duration: 3000
        });
      }
    }
  };
  // Add or modify the handler for the EnhancedSpinWheel component
  const handleWheelRewardClaimed = (reward: any) => {
    // Close the wheel modal
    setShowEnhancedSpinWheel(false);
    // Now complete the ritual after the user has spun the wheel
    if (selectedRitual) {
      updateRitualProgress(selectedRitual.id, selectedRitual.progress + 1);
      if (selectedRitual.progress + 1 >= selectedRitual.required) {
        completeRitual(selectedRitual.id);
        // Show success toast for completing the ritual
        toast.success(`Ritual Completed: ${selectedRitual.title}`, {
          description: `You earned ${reward.name}!`,
          duration: 3000
        });
      }
    }
    // Handle the reward
    if (reward.type === 'tokens') {
      // Add tokens to user balance
      // Implementation depends on your token system
      toast.success(`Earned ${reward.value} Love Tokens!`, {
        duration: 3000
      });
    } else if (reward.type === 'gems') {
      // Add gems to user balance
      toast.success(`Earned ${reward.value} Desire Gems!`, {
        duration: 3000
      });
    } else if (reward.type === 'skin') {
      // Unlock skin
      toast.success(`Unlocked ${reward.name}!`, {
        description: 'Check the Angel Skins Shop to equip it!',
        duration: 3000
      });
    } else if (reward.type === 'tease') {
      // Show tease preview
      toast.success(`Unlocked Tease Preview!`, {
        description: 'Check your rewards section to view it!',
        duration: 3000
      });
    }
  };
  // Function to update achievements
  const updateAchievements = (ritualId: string) => {
    // Dispatch event to update achievements
    const event = new CustomEvent('updateAchievement', {
      detail: {
        ritualId,
        timestamp: Date.now()
      }
    });
    document.dispatchEvent(event);
  };
  // Function to update stats
  const updateStats = (category: string, value: number) => {
    // Dispatch event to update stats
    const event = new CustomEvent('updateStats', {
      detail: {
        category,
        value,
        timestamp: Date.now()
      }
    });
    document.dispatchEvent(event);
  };
  // Function to add to reward hub
  const addToRewardHub = (reward: any) => {
    // Dispatch event to add to reward hub
    const event = new CustomEvent('addReward', {
      detail: reward
    });
    document.dispatchEvent(event);
  };
  // Function to get ritual component mapping
  const getRitualComponentMapping = (ritual: Ritual) => {
    // Check for wheel/spin rituals first to ensure consistent handling
    const title = ritual.title.toLowerCase();
    const desc = ritual.description.toLowerCase();
    // Check for DeepShift or FaceShift rituals
    if (title.includes('deepshift') || desc.includes('deepshift') || title.includes('deep shift') || desc.includes('deep shift') || title.includes('fantasy') && title.includes('scenario') || desc.includes('fantasy') && desc.includes('scenario')) {
      return 'deep_shift';
    }
    if (title.includes('faceshift') || desc.includes('faceshift') || title.includes('face shift') || desc.includes('face shift') || title.includes('swap') && title.includes('face') || desc.includes('swap') && desc.includes('face')) {
      return 'face_shift';
    }
    if (title.includes('wheel') || title.includes('spin') || desc.includes('wheel') || desc.includes('spin')) {
      return 'fortune_wheel'; // Special mapping for wheel/spin rituals
    }
    // Check for Hot or Not rituals
    if (title.includes('hot or not') || desc.includes('hot or not') || title.includes('hotornot') || desc.includes('hotornot')) {
      return 'hot_or_not';
    }
    // Check for privacy-related rituals
    if (title.includes('privacy') || desc.includes('privacy') || title.includes('settings') || desc.includes('settings')) {
      return 'profile_settings';
    }
    // Map ritual categories to component sections
    const categoryMapping: Record<string, string> = {
      chat: 'chat',
      social: 'social_feed',
      profile: 'profile',
      games: 'games',
      marketplace: 'creator_marketplace',
      unleash: 'unleash',
      media: 'creator_marketplace',
      dickpic: 'photo_rating',
      playroom: 'group_chat',
      polls: 'social_polls',
      hot_or_not: 'hot_or_not',
      discovery: 'discovery_feed',
      premium: 'premium',
      subscription: 'subscription',
      bookmarks: 'bookmarks',
      favorites: 'favorites',
      rewards: 'rewards',
      achievements: 'achievements',
      angel: 'discovery_feed',
      deep_shift: 'deep_shift',
      face_shift: 'face_shift'
    };
    // Check specific ritual titles for more precise mapping
    if (title.includes('questionnaire') || desc.includes('questionnaire')) {
      return 'chat';
    }
    if (title.includes('dickpic') || desc.includes('dickpic') || title.includes('photo rating') || desc.includes('photo rating')) {
      return 'photo_rating';
    }
    if (title.includes('playroom') || desc.includes('playroom') || title.includes('group chat') || desc.includes('group chat')) {
      return 'group_chat';
    }
    if (title.includes('poll') || desc.includes('poll')) {
      return 'social_polls';
    }
    if (title.includes('hot or not') || desc.includes('hot or not')) {
      return 'hot_or_not';
    }
    // Check for skin-related rituals
    if (title.includes('skin') || desc.includes('skin') || title.includes('dress up') || desc.includes('dress up')) {
      return 'angel_skins_shop';
    }
    if (title.includes('marketplace') || desc.includes('marketplace')) {
      return 'creator_marketplace';
    }
    if (title.includes('unleash') || desc.includes('unleash') || title.includes('fantasy') || desc.includes('fantasy')) {
      return 'unleash';
    }
    if (title.includes('premium') || desc.includes('premium')) {
      return 'premium';
    }
    if (title.includes('bookmark') || desc.includes('bookmark')) {
      return 'bookmarks';
    }
    if (title.includes('favorite') || desc.includes('favorite')) {
      return 'favorites';
    }
    if (title.includes('lootbox') || desc.includes('lootbox')) {
      return 'rewards';
    }
    if (title.includes('angel') || desc.includes('angel')) {
      return 'discovery_feed';
    }
    if (title.includes('game') || desc.includes('game') || title.includes('minigame') || desc.includes('minigame')) {
      return 'games';
    }
    if (title.includes('angel match') || desc.includes('angel match')) {
      return 'angel_match';
    }
    if (title.includes('live cam') || desc.includes('live cam') || title.includes('livecam') || desc.includes('livecam')) {
      return 'live_cam';
    }
    if (title.includes('vr') || desc.includes('vr') || title.includes('ar') || desc.includes('ar')) {
      return 'vr_ar';
    }
    if (title.includes('fanclub') || desc.includes('fanclub')) {
      return 'fanclub';
    }
    // Fall back to category mapping
    return categoryMapping[ritual.category] || 'social_feed';
  };
  // Function to navigate to component
  const navigateToComponent = (componentMapping: string | null, ritual: Ritual) => {
    if (!componentMapping) {
      // If no component mapping, show the ritual modal instead
      setSelectedRitual(ritual);
      setShowRitualModal(true);
      return;
    }
    // Special handling for DeepShift
    if (componentMapping === 'deep_shift') {
      // Open the DeepShift modal
      const deepShiftEvent = new CustomEvent('openDeepShiftModal', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(deepShiftEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening DeepShift Creator', {
        description: 'Create your fantasy scenario',
        duration: 3000
      });
      return;
    }
    // Special handling for FaceShift
    if (componentMapping === 'face_shift') {
      // Open the FaceShift modal
      const faceShiftEvent = new CustomEvent('openFaceShiftModal', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(faceShiftEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening FaceShift Creator', {
        description: 'Swap faces with your favorite angel',
        duration: 3000
      });
      return;
    }
    // Special handling for Fortune Wheel
    if (componentMapping === 'fortune_wheel') {
      // Open the Enhanced Spin Wheel modal
      setShowEnhancedSpinWheel(true);
      // Don't update ritual progress yet - that happens after spinning
      toast.success('Opening Fortune Wheel', {
        description: 'Spin to earn rewards!',
        duration: 3000
      });
      return;
    }
    // Special handling for Photo Rating
    if (componentMapping === 'photo_rating') {
      setShowPhotoRatingFlow(true);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Photo Rating', {
        description: 'Get feedback on your photos',
        duration: 3000
      });
      return;
    }
    // Special handling for Profile Settings
    if (componentMapping === 'profile_settings') {
      // Open profile settings
      const openProfileEvent = new CustomEvent('openProfileSettings', {
        detail: {
          ritualId: ritual.id
        }
      });
      document.dispatchEvent(openProfileEvent);
      // Update ritual progress
      updateRitualProgress(ritual.id, ritual.progress + 1);
      toast.success('Opening Profile Settings', {
        description: 'Update your profile information',
        duration: 3000
      });
      return;
    }
    // Dispatch navigation event for other components
    const event = new CustomEvent('navigate', {
      detail: {
        section: componentMapping,
        ritualContext: ritual
      }
    });
    document.dispatchEvent(event);
    // Show success toast
    toast.success(`Navigated to ${ritual.title}`, {
      description: 'Complete the action to progress your ritual',
      duration: 3000
    });
    // Update ritual progress for navigation-based rituals
    updateRitualProgress(ritual.id, ritual.progress + 1);
  };
  // Helper functions for modal closing
  const closePremiumModal = () => {
    setShowPremiumModal(false);
  };
  const navigateToPremium = () => {
    setActiveTab('premium');
    setShowPremiumModal(false);
  };
  const handleOpenLootbox = () => {
    if (requiredRitualsCompleted) {
      const reward = claimWeeklyLootbox();
      setLootboxReward(reward);
      setShowLootbox(true);
      setShowReward(true);
    } else {
      setShowPremiumModal(true);
    }
  };
  const handleCloseLootboxReward = () => {
    setShowLootbox(false);
    setShowReward(false);
    setLootboxReward(null);
  };
  // Check if all required rituals are completed
  const requiredRitualsCompleted = areAllRequiredRitualsCompleted();
  // Calculate non-premium rituals completion
  const nonPremiumWeeklyRituals = weeklyRituals.filter(r => !r.requiredForLootbox);
  const nonPremiumCompletedCount = nonPremiumWeeklyRituals.filter(r => r.completed).length;
  const totalNonPremiumWeeklyRituals = nonPremiumWeeklyRituals.length;
  // Add manual rotation button handler
  const handleManualRotation = () => {
    rotateRituals();
  };
  // Add event listener for ritual poll interactions
  useEffect(() => {
    const handleRitualPollVoted = (event: any) => {
      if (event.detail && event.detail.ritualId && event.detail.pollId) {
        // Find the ritual that matches this vote
        const votingRituals = dailyRituals.concat(weeklyRituals, funRituals, premiumRituals).filter(ritual => ritual.title.toLowerCase().includes('vote') || ritual.description.toLowerCase().includes('vote'));
        if (votingRituals.length > 0) {
          // Update progress for voting rituals
          votingRituals.forEach(ritual => {
            updateRitualProgress(ritual.id, ritual.progress + 1);
          });
          // Show toast notification
          toast.success(`Progress updated for poll voting ritual`, {
            description: `You've made progress on your ritual challenge!`,
            duration: 3000
          });
        }
      }
    };
    const handleRitualPollCreated = (event: any) => {
      if (event.detail && event.detail.ritualId && event.detail.pollId) {
        // Find the ritual that matches this poll creation
        const pollCreationRituals = dailyRituals.concat(weeklyRituals, funRituals, premiumRituals).filter(ritual => ritual.title.toLowerCase().includes('create poll') || ritual.title.toLowerCase().includes('run poll') || ritual.description.toLowerCase().includes('create poll') || ritual.description.toLowerCase().includes('run poll'));
        if (pollCreationRituals.length > 0) {
          // Update progress for poll creation rituals
          pollCreationRituals.forEach(ritual => {
            updateRitualProgress(ritual.id, ritual.progress + 1);
          });
          // Show toast notification
          toast.success(`Progress updated for poll creation ritual`, {
            description: `You've made progress on your ritual challenge!`,
            duration: 3000
          });
        }
      }
    };
    // Add event listener for AI creation completions
    const handleAICreationComplete = (event: any) => {
      if (event.detail && event.detail.type) {
        const creationType = event.detail.type.toLowerCase();
        // Find rituals related to AI creation
        const aiCreationRituals = dailyRituals.concat(weeklyRituals, funRituals, premiumRituals).filter(ritual => {
          const title = ritual.title.toLowerCase();
          const desc = ritual.description.toLowerCase();
          if (creationType === 'deep_shift' || creationType === 'deepshift') {
            return title.includes('deepshift') || desc.includes('deepshift') || title.includes('deep shift') || desc.includes('deep shift') || title.includes('fantasy') && title.includes('scenario') || desc.includes('fantasy') && desc.includes('scenario');
          }
          if (creationType === 'face_shift' || creationType === 'faceshift') {
            return title.includes('faceshift') || desc.includes('faceshift') || title.includes('face shift') || desc.includes('face shift') || title.includes('swap') && title.includes('face') || desc.includes('swap') && desc.includes('face');
          }
          return false;
        });
        if (aiCreationRituals.length > 0) {
          // Update progress for AI creation rituals
          aiCreationRituals.forEach(ritual => {
            updateRitualProgress(ritual.id, ritual.progress + 1);
            if (ritual.progress + 1 >= ritual.required) {
              completeRitual(ritual.id);
            }
          });
          // Show toast notification
          toast.success(`AI Creation completed!`, {
            description: `You've made progress on your ritual challenge!`,
            duration: 3000
          });
        }
      }
    };
    document.addEventListener('ritualPollVoted', handleRitualPollVoted as EventListener);
    document.addEventListener('ritualPollCreated', handleRitualPollCreated as EventListener);
    document.addEventListener('aiCreationComplete', handleAICreationComplete as EventListener);
    return () => {
      document.removeEventListener('ritualPollVoted', handleRitualPollVoted as EventListener);
      document.removeEventListener('ritualPollCreated', handleRitualPollCreated as EventListener);
      document.removeEventListener('aiCreationComplete', handleAICreationComplete as EventListener);
    };
  }, [dailyRituals, weeklyRituals, funRituals, premiumRituals]);
  // Add example rituals for DeepShift and FaceShift
  // These would normally come from RitualContext, but we're adding them here for demo purposes
  const exampleDailyRituals = [{
    id: 'daily-deepshift-1',
    title: 'Create Your First DeepShift',
    description: 'Generate your first AI fantasy scenario with DeepShift',
    icon: 'Wand2',
    category: 'deep_shift',
    type: 'daily',
    progress: 0,
    target: 1,
    required: 1,
    reward: {
      type: 'tokens',
      amount: 25
    },
    completed: false,
    isNew: true,
    isHot: true,
    premiumOnly: false,
    requiredForLootbox: false
  }, {
    id: 'daily-faceshift-1',
    title: 'Try FaceShift with an Angel',
    description: 'Swap faces with your favorite angel using FaceShift',
    icon: 'ScanFace',
    category: 'face_shift',
    type: 'daily',
    progress: 0,
    target: 1,
    required: 1,
    reward: {
      type: 'tokens',
      amount: 20
    },
    completed: false,
    isNew: true,
    isHot: false,
    premiumOnly: false,
    requiredForLootbox: false
  }, {
    id: 'daily-deepshift-2',
    title: 'Fantasy Scenario Generator',
    description: 'Create a romantic fantasy scenario with DeepShift',
    icon: 'Sparkles',
    category: 'deep_shift',
    type: 'daily',
    progress: 0,
    target: 1,
    required: 1,
    reward: {
      type: 'tokens',
      amount: 30
    },
    completed: false,
    isNew: false,
    isHot: true,
    premiumOnly: false,
    requiredForLootbox: false
  }, {
    id: 'daily-faceshift-2',
    title: 'Face Swap Adventure',
    description: 'Create a face swap with any angel of your choice',
    icon: 'Image',
    category: 'face_shift',
    type: 'daily',
    progress: 0,
    target: 1,
    required: 1,
    reward: {
      type: 'tokens',
      amount: 25
    },
    completed: false,
    isNew: false,
    isHot: false,
    premiumOnly: false,
    requiredForLootbox: false
  }];
  const exampleFunRituals = [{
    id: 'fun-deepshift-1',
    title: 'DeepShift Dream Date',
    description: 'Create a dream date scenario with your favorite angel',
    icon: 'Heart',
    category: 'deep_shift',
    type: 'fun',
    progress: 0,
    target: 1,
    required: 1,
    reward: {
      type: 'tokens',
      amount: 15
    },
    completed: false,
    isNew: false,
    isHot: true,
    premiumOnly: false,
    requiredForLootbox: false
  }, {
    id: 'fun-faceshift-1',
    title: 'Celebrity FaceShift',
    description: 'Try FaceShift with a celebrity angel from our collection',
    icon: 'Star',
    category: 'face_shift',
    type: 'fun',
    progress: 0,
    target: 1,
    required: 1,
    reward: {
      type: 'tokens',
      amount: 15
    },
    completed: false,
    isNew: true,
    isHot: false,
    premiumOnly: false,
    requiredForLootbox: false
  }, {
    id: 'fun-deepshift-2',
    title: 'Fantasy Location Generator',
    description: 'Create a DeepShift scenario in an exotic location',
    icon: 'Palette',
    category: 'deep_shift',
    type: 'fun',
    progress: 0,
    target: 1,
    required: 1,
    reward: {
      type: 'tokens',
      amount: 20
    },
    completed: false,
    isNew: false,
    isHot: false,
    premiumOnly: false,
    requiredForLootbox: false
  }, {
    id: 'fun-faceshift-2',
    title: "Couple', s, FaceShift,",
    description: 'Create a romantic couple photo with FaceShift',
    icon: 'Users',
    category: 'face_shift',
    type: 'fun',
    progress: 0,
    target: 1,
    required: 1,
    reward: "{ type: 'tokens amount: 20 }",
    completed: false,
    isNew: true,
    isHot: true,
    premiumOnly: false,
    requiredForLootbox: 1
  }];
  const exampleWeeklyRituals = [{
    id: 'weekly-deepshift-1',
    title: 'DeepShift Master',
    description: 'Create 3 different fantasy scenarios with DeepShift',
    icon: 'Wand2',
    category: 'deep_shift',
    type: 'weekly',
    progress: 0,
    target: 3,
    required: 3,
    reward: {
      type: 'tokens',
      amount: 50
    },
    completed: false,
    isNew: false,
    isHot: true,
    premiumOnly: false,
    requiredForLootbox: false
  }, {
    id: 'weekly-faceshift-1',
    title: 'FaceShift Collection',
    description: 'Create 3 different face swaps with FaceShift',
    icon: 'ScanFace',
    category: 'face_shift',
    type: 'weekly',
    progress: 0,
    target: 3,
    required: 3,
    reward: {
      type: 'tokens',
      amount: 45
    },
    completed: false,
    isNew: true,
    isHot: false,
    premiumOnly: false,
    requiredForLootbox: false
  }, {
    id: 'weekly-deepshift-2',
    title: 'Share a DeepShift Creation',
    description: 'Create and share a DeepShift fantasy with friends',
    icon: 'Share2',
    category: 'deep_shift',
    type: 'weekly',
    progress: 0,
    target: 1,
    required: 1,
    reward: {
      type: 'gems',
      amount: 5
    },
    completed: false,
    isNew: false,
    isHot: false,
    premiumOnly: false,
    requiredForLootbox: false
  }, {
    id: 'weekly-faceshift-2',
    title: 'FaceShift Styles',
    description: 'Try 3 different style options in FaceShift',
    icon: 'Brush',
    category: 'face_shift',
    type: 'weekly',
    progress: 0,
    target: 3,
    required: 3,
    reward: {
      type: 'gems',
      amount: 5
    },
    completed: false,
    isNew: true,
    isHot: true,
    premiumOnly: false,
    requiredForLootbox: false
  }];
  const examplePremiumRituals = [{
    id: 'premium-deepshift-1',
    title: 'Premium DeepShift Fantasy',
    description: 'Create a high-quality premium fantasy with DeepShift',
    icon: 'Crown',
    category: 'deep_shift',
    type: 'premium',
    progress: 0,
    target: 1,
    required: 1,
    reward: {
      type: 'gems',
      amount: 15
    },
    completed: false,
    isNew: true,
    isHot: true,
    premiumOnly: true,
    requiredForLootbox: true
  }, {
    id: 'premium-faceshift-1',
    title: 'Premium FaceShift Creation',
    description: 'Create a high-resolution face swap with premium features',
    icon: 'Diamond',
    category: 'face_shift',
    type: 'premium',
    progress: 0,
    target: 1,
    required: 1,
    reward: {
      type: 'gems',
      amount: 10
    },
    completed: false,
    isNew: true,
    isHot: true,
    premiumOnly: true,
    requiredForLootbox: true
  }];
  const renderRitualItem = (ritual: Ritual) => {
    const progressPercentage = ritual.progress / ritual.target * 100;
    const isPremiumRitual = ritual.requiredForLootbox || ritual.premiumOnly;
    return <div key={ritual.id} className={`p-3 relative rounded-lg backdrop-blur-sm shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden
          ${ritual.completed ? 'bg-gradient-to-br from-green-900/10 to-green-900/5 dark:from-green-900/20 dark:to-green-900/10 border border-green-500/20 dark:border-green-500/30 shadow-[0_0_10px_rgba(34,197,94,0.1)] dark:shadow-[0_0_10px_rgba(34,197,94,0.2)]' : isPremiumRitual ? 'bg-gradient-to-br from-amber-900/10 to-amber-900/5 dark:from-amber-900/20 dark:to-amber-900/10 border border-amber-500/30 dark:border-amber-500/40 shadow-[0_0_10px_rgba(245,158,11,0.1)] dark:shadow-[0_0_15px_rgba(245,158,11,0.2)]' : 'bg-gradient-to-br from-gray-900/5 to-gray-900/0 dark:from-gray-800/30 dark:to-gray-800/20 border border-gray-300/30 dark:border-gray-700/40'}`} data-id="element-17829">
        {/* Ritual background effects */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-17830">
          {/* Subtle background patterns */}
          <div className="absolute inset-0 opacity-5 dark:opacity-10 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-17831"></div>
          {/* Ritual completion effects */}
          {ritual.completed && <div className="absolute inset-0 overflow-hidden" data-id="element-17832">
              <div className="absolute inset-0 bg-gradient-to-br from-green-500/5 to-green-500/0 dark:from-green-500/10 dark:to-green-500/0" data-id="element-17833"></div>
              <div className="absolute -right-8 -bottom-8 w-16 h-16 bg-green-500/10 dark:bg-green-500/20 rounded-full blur-xl" data-id="element-17834"></div>
            </div>}
          {/* Premium ritual effects */}
          {isPremiumRitual && !ritual.completed && <div className="absolute inset-0 overflow-hidden" data-id="element-17835">
              <div className="absolute -left-10 -top-10 w-20 h-20 bg-amber-500/10 dark:bg-amber-500/20 rounded-full blur-xl" data-id="element-17836"></div>
              <div className="absolute -right-10 -bottom-10 w-20 h-20 bg-amber-500/10 dark:bg-amber-500/20 rounded-full blur-xl" data-id="element-17837"></div>
            </div>}
          {/* Regular ritual subtle effects */}
          {!isPremiumRitual && !ritual.completed && <div className="absolute inset-0 overflow-hidden" data-id="element-17838">
              {ritual.type === 'daily' && <div className="absolute -right-10 -bottom-10 w-20 h-20 bg-pink-500/5 dark:bg-pink-500/10 rounded-full blur-xl" data-id="element-17839"></div>}
              {ritual.type === 'weekly' && <div className="absolute -right-10 -bottom-10 w-20 h-20 bg-blue-500/5 dark:bg-blue-500/10 rounded-full blur-xl" data-id="element-17840"></div>}
              {ritual.type === 'fun' && <div className="absolute -right-10 -bottom-10 w-20 h-20 bg-cyan-500/5 dark:bg-cyan-500/10 rounded-full blur-xl" data-id="element-17841"></div>}
            </div>}
        </div>
        {/* Premium badge */}
        {isPremiumRitual && !ritual.completed && <div className="absolute -top-2 -right-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs font-bold px-2 py-0.5 rounded-full flex items-center gap-1 shadow-[0_0_10px_rgba(245,158,11,0.3)] dark:shadow-[0_0_10px_rgba(245,158,11,0.4)] animate-pulse-subtle z-10" data-id="element-17842">
            <Flame size={12} data-id="element-17843" />
            <span data-id="element-17844">HOT</span>
          </div>}
        <div className="flex items-start gap-3 relative z-10" data-id="element-17845">
          {/* Ritual icon with glow effect */}
          <div className={`w-10 h-10 flex-shrink-0 rounded-full flex items-center justify-center relative overflow-hidden
              ${ritual.completed ? 'bg-gradient-to-br from-green-500/20 to-green-600/20 dark:from-green-500/30 dark:to-green-600/30 text-green-600 dark:text-green-400 shadow-[0_0_10px_rgba(34,197,94,0.2)] dark:shadow-[0_0_10px_rgba(34,197,94,0.3)]' : isPremiumRitual ? 'bg-gradient-to-br from-amber-500/20 to-amber-600/20 dark:from-amber-500/30 dark:to-amber-600/30 text-amber-600 dark:text-amber-400 shadow-[0_0_10px_rgba(245,158,11,0.2)] dark:shadow-[0_0_10px_rgba(245,158,11,0.3)]' : ritual.type === 'daily' ? 'bg-gradient-to-br from-pink-500/10 to-purple-500/10 dark:from-pink-500/20 dark:to-purple-500/20 text-pink-600 dark:text-pink-400' : ritual.type === 'weekly' ? 'bg-gradient-to-br from-blue-500/10 to-purple-500/10 dark:from-blue-500/20 dark:to-purple-500/20 text-blue-600 dark:text-blue-400' : 'bg-gradient-to-br from-cyan-500/10 to-blue-500/10 dark:from-cyan-500/20 dark:to-blue-500/20 text-cyan-600 dark:text-cyan-400'}`} data-id="element-17846">
            {/* Background pattern */}
            <div className="absolute inset-0 opacity-10 dark:opacity-20 bg-[url('https://www.transparenttextures.com/patterns/diagmonds-light.png')]" data-id="element-17847"></div>
            {/* Animated glow for premium rituals */}
            {isPremiumRitual && !ritual.completed && <div className="absolute inset-0 bg-gradient-to-r from-amber-500/0 via-amber-500/30 to-amber-500/0 animate-shimmer" data-id="element-17848"></div>}
            {/* Icon */}
            <div className="relative z-10" data-id="element-17849">{getIconComponent(ritual.icon)}</div>
          </div>
          <div className="flex-1" data-id="element-17850">
            <div className="flex items-center justify-between" data-id="element-17851">
              <h3 className="font-medium text-sm flex items-center gap-1.5 text-gray-800 dark:text-gray-200" data-id="element-17852">
                {ritual.title}
                {ritual.isNew && <span className="bg-blue-500 text-white text-[10px] px-1.5 py-0.5 rounded-full shadow-[0_0_5px_rgba(59,130,246,0.3)]" data-id="element-17853">
                    NEW
                  </span>}
                {ritual.isHot && !ritual.requiredForLootbox && <span className="bg-pink-500 text-white text-[10px] px-1.5 py-0.5 rounded-full shadow-[0_0_5px_rgba(236,72,153,0.3)]" data-id="element-17854">
                    HOT
                  </span>}
              </h3>
              <div className="text-xs font-semibold" data-id="element-17855">
                {ritual.reward.type === 'tokens' && <span className="text-pink-500 dark:text-pink-400 flex items-center gap-1" data-id="element-17856">
                    <span data-id="element-17857">{ritual.reward.amount}</span>
                    <span className="text-pink-500/80 dark:text-pink-400/80" data-id="element-17858">
                      💗
                    </span>
                  </span>}
                {ritual.reward.type === 'gems' && <span className="text-blue-500 dark:text-blue-400 flex items-center gap-1" data-id="element-17859">
                    <span data-id="element-17860">{ritual.reward.amount}</span>
                    <span className="text-blue-500/80 dark:text-blue-400/80" data-id="element-17861">
                      💎
                    </span>
                  </span>}
                {ritual.reward.type === 'lootbox' && <span className="text-amber-500 dark:text-amber-400 flex items-center gap-1" data-id="element-17862">
                    <span className="text-amber-500/80 dark:text-amber-400/80" data-id="element-17863">
                      🎁
                    </span>
                    <span data-id="element-17864">Lootbox</span>
                  </span>}
              </div>
            </div>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1" data-id="element-17865">
              {ritual.description}
            </p>
            {ritual.requiredForLootbox && <div className="mt-1 flex items-center gap-1 text-amber-600 dark:text-amber-400 text-xs font-medium" data-id="element-17866">
                <LockIcon size={12} data-id="element-17867" />
                <span data-id="element-17868">Required for Weekly Lootbox</span>
              </div>}
            <div className="mt-2" data-id="element-17869">
              <div className="flex items-center justify-between mb-1" data-id="element-17870">
                <span className="text-xs text-gray-500 dark:text-gray-500" data-id="element-17871">
                  Progress
                </span>
                <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-17872">
                  {ritual.progress}/{ritual.target}
                </span>
              </div>
              {/* Energy channel progress bar */}
              <div className="h-2 bg-gray-200/50 dark:bg-gray-800/50 rounded-full overflow-hidden backdrop-blur-sm relative" data-id="element-17873">
                {/* Progress bar background with subtle pattern */}
                <div className="absolute inset-0 opacity-5 dark:opacity-10 bg-[url('https://www.transparenttextures.com/patterns/diagmonds-light.png')]" data-id="element-17874"></div>
                {/* Glowing progress indicator */}
                <div className={`h-full rounded-full relative transition-all duration-500 overflow-hidden
                    ${ritual.completed ? 'bg-gradient-to-r from-green-500 to-green-400' : ritual.requiredForLootbox ? 'bg-gradient-to-r from-amber-500 to-amber-400' : ritual.type === 'daily' ? 'bg-gradient-to-r from-pink-500 to-purple-500' : ritual.type === 'weekly' ? 'bg-gradient-to-r from-blue-500 to-purple-500' : ritual.type === 'monetization' || ritual.type === 'premium' ? 'bg-gradient-to-r from-amber-500 to-orange-500' : 'bg-gradient-to-r from-cyan-500 to-blue-500'}`} style={{
                width: `${progressPercentage}%`
              }} data-id="element-17875">
                  {/* Animated flowing energy effect */}
                  <div className="absolute inset-0 bg-white/20 animate-shimmer" data-id="element-17876"></div>
                  {/* Edge glow effect */}
                  {progressPercentage > 0 && progressPercentage < 100 && <div className="absolute right-0 top-0 bottom-0 w-1.5 bg-white/50 blur-sm" data-id="element-17877"></div>}
                </div>
              </div>
            </div>
            <div className="mt-3 flex items-center gap-2" data-id="element-17878">
              {ritual.completed ? <div className="flex items-center gap-1 text-xs text-green-600 dark:text-green-400 font-medium" data-id="element-17879">
                  <CheckCircle size={14} data-id="element-17880" />
                  <span data-id="element-17881">Completed</span>
                </div> : <>
                  {ritual.premiumOnly || ritual.requiredForLootbox ? <button className="flex-1 py-1.5 rounded-full text-xs font-medium transition-all duration-300 flex items-center justify-center gap-1.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white hover:shadow-md hover:shadow-amber-500/20 relative overflow-hidden" onClick={() => handleRitualAction(ritual)} onMouseEnter={() => setShowTooltip(ritual.id)} onMouseLeave={() => setShowTooltip(null)} data-id="element-17882">
                      <span className="relative z-10" data-id="element-17883">Unlock Now</span>
                      <ShoppingCart size={14} className="relative z-10" data-id="element-17884" />
                      {/* Animated flowing energy effect */}
                      <div className="absolute inset-0 bg-white/10 animate-shimmer" data-id="element-17885"></div>
                      {/* Tooltip for required rituals */}
                      {showTooltip === ritual.id && ritual.requiredForLootbox && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-48 bg-gray-900/90 backdrop-blur-sm text-white text-xs rounded py-1.5 px-2.5 shadow-lg z-20" data-id="element-17886">
                            This ritual is required to claim the Weekly Lootbox
                            <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900/90" data-id="element-17887"></div>
                          </div>}
                    </button> : <button className={`flex-1 py-1.5 rounded-full text-xs font-medium transition-all duration-300 flex items-center justify-center gap-1.5 relative overflow-hidden shadow-sm hover:shadow-md
                        ${ritual.type === 'daily' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white hover:shadow-pink-500/20' : ritual.type === 'weekly' ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:shadow-blue-500/20' : ritual.type === 'monetization' || ritual.type === 'premium' ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white hover:shadow-amber-500/20' : 'bg-gradient-to-r from-cyan-600 to-blue-600 text-white hover:shadow-cyan-500/20'}`} onClick={() => handleRitualAction(ritual)} data-id="element-17888">
                      <span className="relative z-10" data-id="element-17889">Go</span>
                      <ChevronRight size={14} className="relative z-10" data-id="element-17890" />
                      {/* Animated flowing energy effect */}
                      <div className="absolute inset-0 bg-white/10 animate-shimmer" data-id="element-17891"></div>
                    </button>}
                  {ritual.type !== 'monetization' && ritual.type !== 'premium' && !ritual.requiredForLootbox && <button className="py-1.5 px-2 bg-gray-200/70 dark:bg-gray-800/70 backdrop-blur-sm text-gray-700 dark:text-gray-300 rounded-full text-xs font-medium hover:bg-gray-300 dark:hover:bg-gray-700 transition-all duration-300 flex items-center justify-center" onClick={() => skipRitual(ritual.id)} data-id="element-17892">
                        <FastForward size={14} data-id="element-17893" />
                      </button>}
                </>}
            </div>
          </div>
        </div>
      </div>;
  };
  const renderLootboxSection = () => {
    return <div className="mb-6" data-id="element-17894">
        <div className="flex items-center justify-between mb-4" data-id="element-17895">
          <h3 className="text-lg font-bold dark:text-white relative" data-id="element-17896">
            <span className="relative" data-id="element-17897">
              Lootboxes
              <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-purple-500 to-transparent" data-id="element-17898"></span>
            </span>
          </h3>
          <button className="px-3 py-1.5 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg text-sm font-medium hover:shadow-lg hover:shadow-purple-500/20 transition-all relative overflow-hidden" onClick={() => setShowLootboxDashboard(true)} data-id="element-17899">
            <span className="relative z-10" data-id="element-17900">View All Lootboxes</span>
            <div className="absolute inset-0 bg-white/10 animate-shimmer" data-id="element-17901"></div>
          </button>
        </div>
        {/* Preview of available lootboxes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-17902">
          {/* Premium Weekly Lootbox */}
          <div className="relative overflow-hidden rounded-xl border border-purple-500/30 dark:border-purple-500/40 bg-gradient-to-br from-purple-900/10 to-purple-900/5 dark:from-purple-900/20 dark:to-purple-900/10 shadow-[0_0_15px_rgba(168,85,247,0.1)] dark:shadow-[0_0_15px_rgba(168,85,247,0.2)] backdrop-blur-sm" data-id="element-17903">
            <div className="absolute inset-0 opacity-5 dark:opacity-10 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-17904"></div>
            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-purple-600 to-purple-700" data-id="element-17905"></div>
            <div className="p-4 relative z-10" data-id="element-17906">
              <div className="flex items-start gap-3" data-id="element-17907">
                <div className="relative w-16 h-16 flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-purple-600 to-purple-700 rounded-lg overflow-hidden shadow-[0_0_10px_rgba(147,51,234,0.3)] dark:shadow-[0_0_15px_rgba(147,51,234,0.4)]" data-id="element-17908">
                  <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')] opacity-30" data-id="element-17909"></div>
                  <Gift size={24} className="text-purple-300 relative z-10" data-id="element-17910" />
                  {/* Animated glow effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-purple-500/0 via-purple-500/30 to-purple-500/0 animate-shimmer" data-id="element-17911"></div>
                </div>
                <div className="flex-1" data-id="element-17912">
                  <div className="flex items-start justify-between" data-id="element-17913">
                    <div data-id="element-17914">
                      <h4 className="font-medium dark:text-white" data-id="element-17915">
                        Premium Weekly Lootbox
                      </h4>
                      <p className="text-xs text-gray-600 dark:text-gray-400" data-id="element-17916">
                        High-value rewards refresh every week
                      </p>
                    </div>
                    <div className="px-1.5 py-0.5 rounded-sm text-xs bg-gradient-to-r from-purple-600 to-purple-700 text-purple-300" data-id="element-17917">
                      EPIC
                    </div>
                  </div>
                  <div className="mt-2" data-id="element-17918">
                    <div className="flex items-center gap-1 text-xs text-green-500 dark:text-green-400" data-id="element-17919">
                      <Unlock size={12} data-id="element-17920" />
                      <span data-id="element-17921">Ready to open!</span>
                    </div>
                  </div>
                </div>
              </div>
              <button onClick={() => setShowLootboxDashboard(true)} className="w-full py-2 mt-3 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white rounded-lg text-sm font-medium transition-colors animate-pulse-subtle relative overflow-hidden shadow-[0_0_10px_rgba(147,51,234,0.2)] hover:shadow-[0_0_15px_rgba(147,51,234,0.3)]" data-id="element-17922">
                <span className="relative z-10" data-id="element-17923">Open Lootbox</span>
                <div className="absolute inset-0 bg-white/10 animate-shimmer" data-id="element-17924"></div>
              </button>
            </div>
          </div>
          {/* Daily Reward Chest */}
          <div className="relative overflow-hidden rounded-xl border border-gray-300/50 dark:border-gray-700/50 bg-gradient-to-br from-gray-900/5 to-gray-900/0 dark:from-gray-800/30 dark:to-gray-800/20 backdrop-blur-sm" data-id="element-17925">
            <div className="absolute inset-0 opacity-5 dark:opacity-10 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-17926"></div>
            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-gray-600 to-gray-700" data-id="element-17927"></div>
            <div className="p-4 relative z-10" data-id="element-17928">
              <div className="flex items-start gap-3" data-id="element-17929">
                <div className="relative w-16 h-16 flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-gray-600 to-gray-700 rounded-lg overflow-hidden" data-id="element-17930">
                  <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')] opacity-30" data-id="element-17931"></div>
                  <Clock size={24} className="text-gray-300 relative z-10" data-id="element-17932" />
                </div>
                <div className="flex-1" data-id="element-17933">
                  <div className="flex items-start justify-between" data-id="element-17934">
                    <div data-id="element-17935">
                      <h4 className="font-medium dark:text-white" data-id="element-17936">
                        Daily Reward Chest
                      </h4>
                      <p className="text-xs text-gray-600 dark:text-gray-400" data-id="element-17937">
                        Daily rewards for active members
                      </p>
                    </div>
                    <div className="px-1.5 py-0.5 rounded-sm text-xs bg-gradient-to-r from-gray-600 to-gray-700 text-gray-300" data-id="element-17938">
                      COMMON
                    </div>
                  </div>
                  <div className="mt-2" data-id="element-17939">
                    <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400" data-id="element-17940">
                      <Clock size={12} data-id="element-17941" />
                      <span data-id="element-17942">Available in: 03:45:12</span>
                    </div>
                  </div>
                </div>
              </div>
              <button disabled className="w-full py-2 mt-3 bg-gray-100/70 dark:bg-gray-800/70 backdrop-blur-sm text-gray-500 dark:text-gray-400 rounded-lg text-sm font-medium cursor-not-allowed" data-id="element-17943">
                On Cooldown
              </button>
            </div>
          </div>
        </div>
      </div>;
  };
  return <div className="ritual-board-container relative" data-id="element-17944">
      {/* Mystical background effects */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-17945">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-950 dark:to-black opacity-80" data-id="element-17946"></div>
        <div className="absolute inset-0 opacity-5 dark:opacity-10 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-17947"></div>
        {/* Ambient glow effects */}
        <div className="absolute -top-20 -right-20 w-64 h-64 bg-pink-500/5 dark:bg-pink-500/10 rounded-full blur-3xl" data-id="element-17948"></div>
        <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-blue-500/5 dark:bg-blue-500/10 rounded-full blur-3xl" data-id="element-17949"></div>
        {/* Particle effects - using pseudo-elements for better performance */}
        <div className="absolute top-1/4 left-1/4 w-1 h-1 bg-pink-500/30 dark:bg-pink-500/50 rounded-full animate-float-1" data-id="element-17950"></div>
        <div className="absolute top-1/3 right-1/4 w-1 h-1 bg-blue-500/30 dark:bg-blue-500/50 rounded-full animate-float-2" data-id="element-17951"></div>
        <div className="absolute bottom-1/4 left-1/3 w-1 h-1 bg-purple-500/30 dark:bg-purple-500/50 rounded-full animate-float-3" data-id="element-17952"></div>
        <div className="absolute bottom-1/3 right-1/3 w-1 h-1 bg-amber-500/30 dark:bg-amber-500/50 rounded-full animate-float-4" data-id="element-17953"></div>
      </div>
      {/* Header with progress stats - Ritual Tablets */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 relative z-10" data-id="element-17954">
        {/* Daily Rituals Tablet */}
        <div className="relative overflow-hidden rounded-lg p-4 text-white shadow-lg backdrop-blur-sm" data-id="element-17955">
          {/* Moonlit purple glow background */}
          <div className="absolute inset-0 bg-gradient-to-br from-pink-900/80 to-purple-900/80 dark:from-pink-900/90 dark:to-purple-900/90" data-id="element-17956"></div>
          <div className="absolute inset-0 opacity-10 dark:opacity-20 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-17957"></div>
          {/* Ambient glow effects */}
          <div className="absolute -top-10 -right-10 w-20 h-20 bg-pink-500/30 dark:bg-pink-500/40 rounded-full blur-xl" data-id="element-17958"></div>
          <div className="absolute -bottom-10 -left-10 w-20 h-20 bg-purple-500/30 dark:bg-purple-500/40 rounded-full blur-xl" data-id="element-17959"></div>
          {/* Content */}
          <div className="relative z-10" data-id="element-17960">
            <div className="flex items-center justify-between mb-2" data-id="element-17961">
              <h3 className="font-bold text-sm flex items-center gap-1.5" data-id="element-17962">
                <Trophy size={18} className="text-pink-300" data-id="element-17963" /> Daily Rituals
              </h3>
              <span className="text-sm font-medium bg-white/10 backdrop-blur-sm rounded-full px-2.5 py-0.5" data-id="element-17964">
                {todayCompletedCount}/{totalDailyRituals}
              </span>
            </div>
            {/* Energy channel progress bar */}
            <div className="h-2 bg-white/10 backdrop-blur-sm rounded-full overflow-hidden" data-id="element-17965">
              <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all duration-500 relative" data-id="element-17966">
                <div className="absolute inset-0 w-full h-full" style={{
                width: `${todayCompletedCount / totalDailyRituals * 100}%`
              }} data-id="element-17967">
                  {/* Animated flowing energy effect */}
                  <div className="absolute inset-0 bg-white/20 animate-shimmer" data-id="element-17968"></div>
                  {/* Edge glow effect */}
                  {todayCompletedCount > 0 && todayCompletedCount < totalDailyRituals && <div className="absolute right-0 top-0 bottom-0 w-1.5 bg-white/50 blur-sm" data-id="element-17969"></div>}
                </div>
              </div>
            </div>
            <div className="mt-3 flex items-center justify-between" data-id="element-17970">
              <div className="flex items-center gap-1.5" data-id="element-17971">
                <Zap size={16} className="text-pink-300" data-id="element-17972" />
                <span className="text-sm" data-id="element-17973">
                  Current Streak:{' '}
                  <span className="font-bold" data-id="element-17974">{streakCount} days</span>
                </span>
              </div>
              <div className="flex items-center gap-1.5 text-xs bg-white/10 backdrop-blur-sm rounded-full px-2 py-0.5" data-id="element-17975">
                <RefreshCw size={12} className="text-pink-300" data-id="element-17976" />
                <span data-id="element-17977">Rotates in: {timeUntilDailyRotation}</span>
              </div>
            </div>
          </div>
        </div>
        {/* Weekly Rituals Tablet */}
        <div className="relative overflow-hidden rounded-lg p-4 text-white shadow-lg backdrop-blur-sm" data-id="element-17978">
          {/* Celestial blue glow background */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/80 to-indigo-900/80 dark:from-blue-900/90 dark:to-indigo-900/90" data-id="element-17979"></div>
          <div className="absolute inset-0 opacity-10 dark:opacity-20 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-17980"></div>
          {/* Ambient glow effects */}
          <div className="absolute -top-10 -right-10 w-20 h-20 bg-blue-500/30 dark:bg-blue-500/40 rounded-full blur-xl" data-id="element-17981"></div>
          <div className="absolute -bottom-10 -left-10 w-20 h-20 bg-indigo-500/30 dark:bg-indigo-500/40 rounded-full blur-xl" data-id="element-17982"></div>
          {/* Premium badge */}
          {!requiredRitualsCompleted && <div className="absolute -right-6 -top-6 w-24 h-24 flex items-center justify-center" data-id="element-17983">
              <div className="absolute inset-0 bg-amber-500/40 dark:bg-amber-500/50 opacity-20 rotate-45" data-id="element-17984"></div>
              <div className="relative transform rotate-45 bg-amber-500 text-white text-xs font-bold py-1 px-2 shadow-[0_0_10px_rgba(245,158,11,0.3)]" data-id="element-17985">
                PREMIUM
              </div>
            </div>}
          {/* Content */}
          <div className="relative z-10" data-id="element-17986">
            <div className="flex items-center justify-between mb-2" data-id="element-17987">
              <h3 className="font-bold text-sm flex items-center gap-1.5" data-id="element-17988">
                <Calendar size={18} className="text-blue-300" data-id="element-17989" /> Weekly Rituals
              </h3>
              <span className="text-sm font-medium bg-white/10 backdrop-blur-sm rounded-full px-2.5 py-0.5" data-id="element-17990">
                {weeklyCompletedCount}/{totalWeeklyRituals}
              </span>
            </div>
            {/* Energy channel progress bar */}
            <div className="h-2 bg-white/10 backdrop-blur-sm rounded-full overflow-hidden" data-id="element-17991">
              <div className="h-full bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full transition-all duration-500 relative" data-id="element-17992">
                <div className="absolute inset-0 w-full h-full" style={{
                width: `${weeklyCompletedCount / totalWeeklyRituals * 100}%`
              }} data-id="element-17993">
                  {/* Animated flowing energy effect */}
                  <div className="absolute inset-0 bg-white/20 animate-shimmer" data-id="element-17994"></div>
                  {/* Edge glow effect */}
                  {weeklyCompletedCount > 0 && weeklyCompletedCount < totalWeeklyRituals && <div className="absolute right-0 top-0 bottom-0 w-1.5 bg-white/50 blur-sm" data-id="element-17995"></div>}
                </div>
              </div>
            </div>
            {!requiredRitualsCompleted && <div className="mt-2 flex items-center gap-1.5 text-amber-200 text-xs" data-id="element-17996">
                <AlertTriangle size={14} data-id="element-17997" />
                <span data-id="element-17998">Premium Ritual Required!</span>
              </div>}
            <div className="mt-1 flex items-center justify-between" data-id="element-17999">
              <div className="flex items-center gap-1.5" data-id="element-18000">
                <Package size={16} className="text-blue-300" data-id="element-18001" />
                <span className="text-sm" data-id="element-18002">
                  Weekly Streak:{' '}
                  <span className="font-bold" data-id="element-18003">{weeklyStreakCount}</span>
                </span>
              </div>
              <div className="flex items-center gap-1.5 text-xs bg-white/10 backdrop-blur-sm rounded-full px-2 py-0.5" data-id="element-18004">
                <RefreshCw size={12} className="text-blue-300" data-id="element-18005" />
                <span data-id="element-18006">Rotates in: {timeUntilWeeklyRotation}</span>
              </div>
            </div>
          </div>
        </div>
        {/* Premium Rituals Tablet */}
        <div className="relative overflow-hidden rounded-lg p-4 text-white shadow-lg backdrop-blur-sm" data-id="element-18007">
          {/* Golden flame glow background */}
          <div className="absolute inset-0 bg-gradient-to-br from-amber-900/80 to-orange-900/80 dark:from-amber-900/90 dark:to-orange-900/90" data-id="element-18008"></div>
          <div className="absolute inset-0 opacity-10 dark:opacity-20 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-18009"></div>
          {/* Ambient glow effects */}
          <div className="absolute -top-10 -right-10 w-20 h-20 bg-amber-500/30 dark:bg-amber-500/40 rounded-full blur-xl" data-id="element-18010"></div>
          <div className="absolute -bottom-10 -left-10 w-20 h-20 bg-orange-500/30 dark:bg-orange-500/40 rounded-full blur-xl" data-id="element-18011"></div>
          {/* Content */}
          <div className="relative z-10" data-id="element-18012">
            <div className="flex items-center justify-between mb-2" data-id="element-18013">
              <h3 className="font-bold text-sm flex items-center gap-1.5" data-id="element-18014">
                <Diamond size={18} className="text-amber-300" data-id="element-18015" /> Premium Rituals
              </h3>
              <span className="text-sm font-medium bg-white/10 backdrop-blur-sm rounded-full px-2.5 py-0.5" data-id="element-18016">
                Boost Rewards
              </span>
            </div>
            <p className="text-sm text-white/90 mb-3" data-id="element-18017">
              Complete premium rituals to unlock your Weekly Lootbox and
              exclusive content
            </p>
            <div className="flex items-center gap-2" data-id="element-18018">
              <button className="flex-1 py-1.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium transition-all duration-300 flex items-center justify-center gap-1.5" onClick={() => setActiveTab('premium')} data-id="element-18019">
                <DollarSign size={14} className="text-amber-300" data-id="element-18020" />
                <span data-id="element-18021">View Premium Rituals</span>
              </button>
              <button className="p-1.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium transition-all duration-300 flex items-center justify-center" onClick={handleManualRotation} title="Force ritual rotation (for testing)" data-id="element-18022">
                <RotateCw size={18} className="text-amber-300" data-id="element-18023" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {renderLootboxSection()}
      {/* Weekly Lootbox Status Banner */}
      {activeTab === 'weekly' && <div className="mb-6 p-4 rounded-lg relative overflow-hidden backdrop-blur-sm shadow-sm" data-id="element-18024">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/10 to-indigo-900/5 dark:from-blue-900/20 dark:to-indigo-900/10 border border-blue-500/20 dark:border-blue-500/30" data-id="element-18025"></div>
          <div className="absolute inset-0 opacity-5 dark:opacity-10 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-18026"></div>
          {/* Ambient glow effects */}
          <div className="absolute -top-10 -right-10 w-20 h-20 bg-blue-500/10 dark:bg-blue-500/20 rounded-full blur-xl" data-id="element-18027"></div>
          <div className="absolute -bottom-10 -left-10 w-20 h-20 bg-indigo-500/10 dark:bg-indigo-500/20 rounded-full blur-xl" data-id="element-18028"></div>
          <div className="flex items-center gap-3 relative z-10" data-id="element-18029">
            <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 flex items-center justify-center shadow-[0_0_10px_rgba(59,130,246,0.3)] dark:shadow-[0_0_10px_rgba(59,130,246,0.4)]" data-id="element-18030">
              <RefreshCw size={18} className="text-white" data-id="element-18031" />
            </div>
            {/* Rotating outer ring */}
            <div className="absolute inset-0 w-full h-full rounded-full border-2 border-blue-400/30 dark:border-blue-400/40 animate-spin" style={{
          animationDuration: '30s'
        }} data-id="element-18032"></div>
          </div>
          <div className="flex-1" data-id="element-18033">
            <h3 className="font-medium text-base text-blue-800 dark:text-blue-300" data-id="element-18034">
              Ritual Rotation System
            </h3>
            <p className="text-xs text-blue-700 dark:text-blue-400 mt-1" data-id="element-18035">
              Daily rituals rotate every 24 hours. Weekly rituals rotate every 7
              days. Your progress is saved even when rituals rotate out.
            </p>
          </div>
          <div className="flex items-center gap-2" data-id="element-18036">
            <div className="text-xs font-medium text-blue-700 dark:text-blue-400" data-id="element-18037">
              <div className="flex items-center gap-1" data-id="element-18038">
                <Hourglass size={10} data-id="element-18039" />
                <span data-id="element-18040">Daily: {timeUntilDailyRotation}</span>
              </div>
              <div className="flex items-center gap-1 mt-1" data-id="element-18041">
                <Calendar size={10} data-id="element-18042" />
                <span data-id="element-18043">Weekly: {timeUntilWeeklyRotation}</span>
              </div>
            </div>
          </div>
        </div>}
      {/* Tabs for different ritual types - Engraved tabs */}
      <div className="flex items-center gap-2 mb-4 overflow-x-auto pb-2 scrollbar-hide relative z-10" data-id="element-18044">
        <button className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center gap-1.5 relative overflow-hidden backdrop-blur-sm
            ${activeTab === 'daily' ? 'bg-gradient-to-r from-pink-900/50 to-purple-900/50 dark:from-pink-900/60 dark:to-purple-900/60 text-white shadow-md shadow-pink-500/10 dark:shadow-pink-500/20' : 'bg-gray-900/5 dark:bg-gray-900/20 text-gray-700 dark:text-gray-300 hover:bg-gray-900/10 dark:hover:bg-gray-900/30'}`} onClick={() => setActiveTab('daily')} data-id="element-18045">
          <Trophy size={16} className={activeTab === 'daily' ? 'text-pink-300' : ''} data-id="element-18046" />
          <span data-id="element-18047">Daily Core Rituals</span>
          <span className="ml-1 bg-white/20 backdrop-blur-sm px-1.5 py-0.5 rounded-full text-xs" data-id="element-18048">
            {dailyRituals.length}
          </span>
          {/* Underline glow for active tab */}
          {activeTab === 'daily' && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-pink-500 to-transparent" data-id="element-18049"></span>}
          {/* Subtle hover animation */}
          {activeTab === 'daily' && <div className="absolute inset-0 bg-white/5 animate-shimmer" data-id="element-18050"></div>}
        </button>
        <button className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center gap-1.5 relative overflow-hidden backdrop-blur-sm
            ${activeTab === 'fun' ? 'bg-gradient-to-r from-cyan-900/50 to-blue-900/50 dark:from-cyan-900/60 dark:to-blue-900/60 text-white shadow-md shadow-cyan-500/10 dark:shadow-cyan-500/20' : 'bg-gray-900/5 dark:bg-gray-900/20 text-gray-700 dark:text-gray-300 hover:bg-gray-900/10 dark:hover:bg-gray-900/30'}`} onClick={() => setActiveTab('fun')} data-id="element-18051">
          <Sparkles size={16} className={activeTab === 'fun' ? 'text-cyan-300' : ''} data-id="element-18052" />
          <span data-id="element-18053">Fun Rituals</span>
          <span className="ml-1 bg-white/20 backdrop-blur-sm px-1.5 py-0.5 rounded-full text-xs" data-id="element-18054">
            {funRituals.length}
          </span>
          {/* Underline glow for active tab */}
          {activeTab === 'fun' && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-cyan-500 to-transparent" data-id="element-18055"></span>}
          {/* Subtle hover animation */}
          {activeTab === 'fun' && <div className="absolute inset-0 bg-white/5 animate-shimmer" data-id="element-18056"></div>}
        </button>
        <button className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center gap-1.5 relative overflow-hidden backdrop-blur-sm
            ${activeTab === 'weekly' ? 'bg-gradient-to-r from-blue-900/50 to-purple-900/50 dark:from-blue-900/60 dark:to-purple-900/60 text-white shadow-md shadow-blue-500/10 dark:shadow-blue-500/20' : 'bg-gray-900/5 dark:bg-gray-900/20 text-gray-700 dark:text-gray-300 hover:bg-gray-900/10 dark:hover:bg-gray-900/30'}`} onClick={() => setActiveTab('weekly')} data-id="element-18057">
          <Calendar size={16} className={activeTab === 'weekly' ? 'text-blue-300' : ''} data-id="element-18058" />
          <span data-id="element-18059">Weekly Rituals</span>
          <span className="ml-1 bg-white/20 backdrop-blur-sm px-1.5 py-0.5 rounded-full text-xs" data-id="element-18060">
            {weeklyRituals.length}
          </span>
          {!requiredRitualsCompleted && <span className="ml-1 w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-18061"></span>}
          {/* Underline glow for active tab */}
          {activeTab === 'weekly' && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-blue-500 to-transparent" data-id="element-18062"></span>}
          {/* Subtle hover animation */}
          {activeTab === 'weekly' && <div className="absolute inset-0 bg-white/5 animate-shimmer" data-id="element-18063"></div>}
        </button>
        <button className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center gap-1.5 relative overflow-hidden backdrop-blur-sm
            ${activeTab === 'premium' ? 'bg-gradient-to-r from-amber-900/50 to-orange-900/50 dark:from-amber-900/60 dark:to-orange-900/60 text-white shadow-md shadow-amber-500/10 dark:shadow-amber-500/20' : 'bg-gray-900/5 dark:bg-gray-900/20 text-gray-700 dark:text-gray-300 hover:bg-gray-900/10 dark:hover:bg-gray-900/30'}`} onClick={() => setActiveTab('premium')} data-id="element-18064">
          <Diamond size={16} className={activeTab === 'premium' ? 'text-amber-300' : ''} data-id="element-18065" />
          <span data-id="element-18066">Premium Rituals</span>
          <span className="ml-1 bg-white/20 backdrop-blur-sm px-1.5 py-0.5 rounded-full text-xs" data-id="element-18067">
            {premiumRituals.length}
          </span>
          {!requiredRitualsCompleted && <span className="ml-1 bg-amber-200 text-amber-900 text-[10px] px-1.5 py-0.5 rounded-full animate-pulse-subtle" data-id="element-18068">
              Required
            </span>}
          {/* Underline glow for active tab */}
          {activeTab === 'premium' && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-amber-500 to-transparent" data-id="element-18069"></span>}
          {/* Subtle hover animation */}
          {activeTab === 'premium' && <div className="absolute inset-0 bg-white/5 animate-shimmer" data-id="element-18070"></div>}
        </button>
      </div>
      {/* Premium Rituals Explainer (shown when premium tab is active) */}
      {activeTab === 'premium' && <div className="mb-6 relative overflow-hidden rounded-lg p-4 shadow-sm backdrop-blur-sm" data-id="element-18071">
          <div className="absolute inset-0 bg-gradient-to-br from-amber-900/10 to-amber-900/5 dark:from-amber-900/20 dark:to-amber-900/10 border border-amber-500/20 dark:border-amber-500/30" data-id="element-18072"></div>
          <div className="absolute inset-0 opacity-5 dark:opacity-10 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-18073"></div>
          {/* Ambient glow effects */}
          <div className="absolute -top-10 -right-10 w-20 h-20 bg-amber-500/10 dark:bg-amber-500/20 rounded-full blur-xl" data-id="element-18074"></div>
          <div className="absolute -bottom-10 -left-10 w-20 h-20 bg-orange-500/10 dark:bg-orange-500/20 rounded-full blur-xl" data-id="element-18075"></div>
          <div className="flex flex-col md:flex-row items-start gap-4 relative z-10" data-id="element-18076">
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-amber-400 to-orange-400 flex items-center justify-center flex-shrink-0 shadow-[0_0_10px_rgba(245,158,11,0.3)] dark:shadow-[0_0_15px_rgba(245,158,11,0.4)]" data-id="element-18077">
              <Diamond size={32} className="text-white" data-id="element-18078" />
            </div>
            <div data-id="element-18079">
              <h3 className="text-lg font-bold text-amber-800 dark:text-amber-400 mb-1" data-id="element-18080">
                Premium Rituals Unlock Weekly Lootbox
              </h3>
              <p className="text-sm text-amber-700 dark:text-amber-300 mb-3" data-id="element-18081">
                Only Premium Supporters can unlock the full reward. Complete
                premium rituals to earn exclusive rewards and access your Weekly
                Lootbox.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-18082">
                <div className="bg-amber-900/10 dark:bg-amber-900/20 backdrop-blur-sm text-amber-800 dark:text-amber-300 text-xs font-medium px-2 py-1 rounded-full flex items-center gap-1 border border-amber-500/20 dark:border-amber-500/30" data-id="element-18083">
                  <CheckCircle size={12} data-id="element-18084" />
                  <span data-id="element-18085">Double XP Rewards</span>
                </div>
                <div className="bg-amber-900/10 dark:bg-amber-900/20 backdrop-blur-sm text-amber-800 dark:text-amber-300 text-xs font-medium px-2 py-1 rounded-full flex items-center gap-1 border border-amber-500/20 dark:border-amber-500/30" data-id="element-18086">
                  <CheckCircle size={12} data-id="element-18087" />
                  <span data-id="element-18088">Bonus Gems</span>
                </div>
                <div className="bg-amber-900/10 dark:bg-amber-900/20 backdrop-blur-sm text-amber-800 dark:text-amber-300 text-xs font-medium px-2 py-1 rounded-full flex items-center gap-1 border border-amber-500/20 dark:border-amber-500/30" data-id="element-18089">
                  <CheckCircle size={12} data-id="element-18090" />
                  <span data-id="element-18091">Exclusive Skin Chances</span>
                </div>
                <div className="bg-amber-900/10 dark:bg-amber-900/20 backdrop-blur-sm text-amber-800 dark:text-amber-300 text-xs font-medium px-2 py-1 rounded-full flex items-center gap-1 border border-amber-500/20 dark:border-amber-500/30" data-id="element-18092">
                  <CheckCircle size={12} data-id="element-18093" />
                  <span data-id="element-18094">Unlocks Weekly Lootbox</span>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* Ritual list */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative z-10" data-id="element-18095">
        {activeTab === 'daily' && [...dailyRituals, ...exampleDailyRituals].map(ritual => renderRitualItem(ritual))}
        {activeTab === 'fun' && [...funRituals, ...exampleFunRituals].map(ritual => renderRitualItem(ritual))}
        {activeTab === 'weekly' && [...weeklyRituals, ...exampleWeeklyRituals].map(ritual => renderRitualItem(ritual))}
        {activeTab === 'premium' && [...premiumRituals, ...examplePremiumRituals].map(ritual => renderRitualItem(ritual))}
      </div>
      {/* Rotation Info Banner - Celestial Clock */}
      <div className="mt-6 p-4 relative overflow-hidden rounded-lg backdrop-blur-sm shadow-sm" data-id="element-18096">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/10 to-indigo-900/5 dark:from-blue-900/20 dark:to-indigo-900/10 border border-blue-500/20 dark:border-blue-500/30" data-id="element-18097"></div>
        <div className="absolute inset-0 opacity-5 dark:opacity-10 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-18098"></div>
        {/* Ambient glow effects */}
        <div className="absolute -top-10 -right-10 w-20 h-20 bg-blue-500/10 dark:bg-blue-500/20 rounded-full blur-xl" data-id="element-18099"></div>
        <div className="absolute -bottom-10 -left-10 w-20 h-20 bg-indigo-500/10 dark:bg-indigo-500/20 rounded-full blur-xl" data-id="element-18100"></div>
        <div className="flex items-center gap-3 relative z-10" data-id="element-18101">
          {/* Celestial clock icon */}
          <div className="relative w-10 h-10 flex-shrink-0" data-id="element-18102">
            <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 flex items-center justify-center shadow-[0_0_10px_rgba(59,130,246,0.3)] dark:shadow-[0_0_10px_rgba(59,130,246,0.4)]" data-id="element-18103">
              <RefreshCw size={18} className="text-white" data-id="element-18104" />
            </div>
            {/* Rotating outer ring */}
            <div className="absolute inset-0 w-full h-full rounded-full border-2 border-blue-400/30 dark:border-blue-400/40 animate-spin" style={{
            animationDuration: '30s'
          }} data-id="element-18105"></div>
          </div>
          <div className="flex-1" data-id="element-18106">
            <h3 className="font-medium text-base text-blue-800 dark:text-blue-300" data-id="element-18107">
              Ritual Rotation System
            </h3>
            <p className="text-xs text-blue-700 dark:text-blue-400 mt-1" data-id="element-18108">
              Daily rituals rotate every 24 hours. Weekly rituals rotate every 7
              days. Your progress is saved even when rituals rotate out.
            </p>
          </div>
          <div className="flex items-center gap-2" data-id="element-18109">
            <div className="text-xs font-medium text-blue-700 dark:text-blue-400" data-id="element-18110">
              <div className="flex items-center gap-1" data-id="element-18111">
                <Hourglass size={10} data-id="element-18112" />
                <span data-id="element-18113">Daily: {timeUntilDailyRotation}</span>
              </div>
              <div className="flex items-center gap-1 mt-1" data-id="element-18114">
                <Calendar size={10} data-id="element-18115" />
                <span data-id="element-18116">Weekly: {timeUntilWeeklyRotation}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Premium required modal */}
      {showPremiumModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-18117">
          <div className="relative max-w-md w-full rounded-2xl overflow-hidden bg-gradient-to-br from-amber-900/90 to-orange-900/90 dark:from-amber-900/95 dark:to-orange-900/95 p-6 shadow-2xl border border-amber-500/30 dark:border-amber-500/40 animate-in zoom-in-95 duration-300" data-id="element-18118">
            <div className="absolute inset-0 opacity-10 dark:opacity-20 bg-[url('https://www.transparenttextures.com/patterns/escheresque-dark.png')]" data-id="element-18119"></div>
            {/* Ambient glow effects */}
            <div className="absolute -top-20 -right-20 w-40 h-40 bg-amber-500/20 dark:bg-amber-500/30 rounded-full blur-xl" data-id="element-18120"></div>
            <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-orange-500/20 dark:bg-orange-500/30 rounded-full blur-xl" data-id="element-18121"></div>
            <button className="absolute right-4 top-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm text-white/80 hover:bg-white/20 transition-colors" onClick={closePremiumModal} data-id="element-18122">
              <X size={18} data-id="element-18123" />
            </button>
            <div className="flex flex-col items-center text-center relative z-10" data-id="element-18124">
              <div className="w-20 h-20 rounded-full bg-gradient-to-r from-amber-400 to-orange-400 flex items-center justify-center mb-4 shadow-[0_0_15px_rgba(245,158,11,0.4)] dark:shadow-[0_0_20px_rgba(245,158,11,0.5)]" data-id="element-18125">
                <LockIcon size={36} className="text-white" data-id="element-18126" />
              </div>
              <h2 className="text-xl font-bold text-white mb-2" data-id="element-18127">
                Premium Ritual Required
              </h2>
              <p className="text-amber-100 mb-4" data-id="element-18128">
                Complete the Premium Ritual to unlock your Weekly Epic Lootbox
                with exclusive rewards and mystery bonuses!
              </p>
              <div className="w-full bg-white/10 backdrop-blur-sm rounded-lg p-4 mb-4" data-id="element-18129">
                <div className="flex items-center gap-3" data-id="element-18130">
                  <div className="w-12 h-12 bg-gradient-to-r from-amber-500 to-orange-500 rounded-lg flex items-center justify-center shadow-[0_0_10px_rgba(245,158,11,0.3)]" data-id="element-18131">
                    {selectedRitual && getIconComponent(selectedRitual.icon, 24)}
                  </div>
                  <div className="flex-1 text-left" data-id="element-18132">
                    <h4 className="font-medium text-white" data-id="element-18133">
                      {selectedRitual ? selectedRitual.title : 'Premium Ritual'}
                    </h4>
                    <p className="text-xs text-amber-200" data-id="element-18134">
                      {selectedRitual ? selectedRitual.description : 'Complete this ritual to unlock premium rewards'}
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full bg-white/10 backdrop-blur-sm rounded-lg p-4 mb-6" data-id="element-18135">
                <h3 className="font-medium text-white mb-2 text-left" data-id="element-18136">Cost</h3>
                <div className="flex items-center justify-between" data-id="element-18137">
                  <div className="flex items-center gap-2" data-id="element-18138">
                    {selectedRitual && (selectedRitual.category === 'unleash' || selectedRitual.category === 'media' || selectedRitual.category === 'marketplace' && selectedRitual.title.includes('skin')) ? <>
                        <Diamond size={18} className="text-blue-300" data-id="element-18139" />
                        <span className="text-amber-200" data-id="element-18140">
                          {selectedRitual.category === 'unleash' ? '25' : selectedRitual.title.includes('video') ? '50' : '20'}{' '}
                          Gems
                        </span>
                      </> : <>
                        <Coins size={18} className="text-pink-300" data-id="element-18141" />
                        <span className="text-amber-200" data-id="element-18142">
                          {selectedRitual && selectedRitual.category === 'dickpic' ? '30' : selectedRitual && selectedRitual.category === 'playroom' ? '40' : selectedRitual && selectedRitual.category === 'marketplace' ? '25' : '15'}{' '}
                          LuvTokens
                        </span>
                      </>}
                  </div>
                  <div className="flex items-center gap-2" data-id="element-18143">
                    <span className="text-amber-200" data-id="element-18144">Balance:</span>
                    <div className="flex items-center gap-1" data-id="element-18145">
                      <Coins size={14} className="text-pink-300" data-id="element-18146" />
                      <span className="text-amber-200" data-id="element-18147">{tokenBalance}</span>
                    </div>
                    <div className="flex items-center gap-1" data-id="element-18148">
                      <Diamond size={14} className="text-blue-300" data-id="element-18149" />
                      <span className="text-amber-200" data-id="element-18150">{gemBalance}</span>
                    </div>
                  </div>
                </div>
              </div>
              <button className="w-full py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg text-sm font-medium hover:shadow-lg hover:shadow-amber-500/20 transition-all duration-300 flex items-center justify-center gap-2 relative overflow-hidden" onClick={handlePremiumSpend} data-id="element-18151">
                <ShoppingCart size={18} data-id="element-18152" />
                <span className="relative z-10" data-id="element-18153">Confirm Purchase</span>
                <div className="absolute inset-0 bg-white/10 animate-shimmer" data-id="element-18154"></div>
              </button>
              <button className="mt-3 text-xs text-amber-200 hover:text-amber-100 hover:underline" onClick={() => setShowPremiumModal(false)} data-id="element-18155">
                I'll do this later
              </button>
            </div>
          </div>
        </div>}
      {/* Lootbox Dashboard Modal */}
      {showLootboxDashboard && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-18156">
          <div className="relative max-w-4xl w-full max-h-[90vh] overflow-auto rounded-2xl bg-gradient-to-br from-purple-900/90 to-indigo-900/90 dark:from-purple-900/95 dark:to-indigo-900/95 p-6 shadow-2xl border border-purple-500/30 dark:border-purple-500/40 animate-in zoom-in-95 duration-300" data-id="element-18157">
            <button className="absolute right-4 top-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm text-white/80 hover:bg-white/20 transition-colors" onClick={() => setShowLootboxDashboard(false)} data-id="element-18158">
              <X size={18} data-id="element-18159" />
            </button>
            <LootboxDashboard onClose={() => setShowLootboxDashboard(false)} data-id="element-18160" />
          </div>
        </div>}
      {/* Lootbox Opening Modal */}
      {showLootbox && lootboxReward && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-18161">
          <div className="relative max-w-md w-full rounded-2xl overflow-hidden bg-gradient-to-br from-purple-900/90 to-indigo-900/90 dark:from-purple-900/95 dark:to-indigo-900/95 p-6 shadow-2xl border border-purple-500/30 dark:border-purple-500/40 animate-in zoom-in-95 duration-300" data-id="element-18162">
            <LootboxOpening reward={lootboxReward} onClose={handleCloseLootboxReward} showReward={showReward} data-id="element-18163" />
          </div>
        </div>}
      {/* Photo Rating Flow Modal */}
      {showPhotoRatingFlow && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-18164">
          <PhotoRatingFlow onClose={() => setShowPhotoRatingFlow(false)} data-id="element-18165" />
        </div>}
      {/* Dickpic Rating Upsell Modal */}
      {showDickpicRatingUpsell && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-18166">
          <div className="relative max-w-md w-full rounded-2xl overflow-hidden bg-white dark:bg-gray-900 p-6 shadow-2xl animate-in zoom-in-95 duration-300" data-id="element-18167">
            <button className="absolute right-4 top-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400" onClick={() => setShowDickpicRatingUpsell(false)} data-id="element-18168">
              <X size={18} data-id="element-18169" />
            </button>
            <DickpicRatingUpsell onClose={() => setShowDickpicRatingUpsell(false)} data-id="element-18170" />
          </div>
        </div>}
      {/* Other modals remain the same with style updates */}
      {/* ... existing modal code ... */}
    </div>;
};